// Переводы 23 страниц лечения.
// Формат: { "/slug": { title, eyebrow, lead, cta, heroAlt, stats, candidate,
//   techniques, journey, risks, faq, ctaBand, disclaimer, seoTitle, seoDesc } }
// Текст написан по тем же клиническим правилам, что и английский оригинал:
// без обещаний и превосходных степеней, все сроки и риски указаны диапазонами.
export default {
  "/abdominoplasty": {
    "title": "Абдоминопластика (подтяжка живота) в Стамбуле",
    "eyebrow": "Контурирование тела",
    "lead": "Абдоминопластика удаляет излишки кожи и жира, которые не уходят ни с диетой, ни с тренировками, и подтягивает мышечный слой брюшной стенки под ними. Это контурирование тела, а не операция по снижению веса.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по абдоминопластике в Platinya Clinic",
    "stats": [
      {
        "value": "2–4 ч",
        "label": "Длительность операции"
      },
      {
        "value": "1–2 ночи",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "2–3 недели",
        "label": "Возвращение к офисной работе"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Операция даёт лучший результат тем, у кого вес стабилен не менее полугода, кто в целом здоров и кого заботит форма, а не килограммы.",
      "items": [
        "Дряблая кожа или расхождение мышц живота после беременности",
        "Обвисшая кожа после значительного снижения веса, когда вес уже перестал меняться",
        "Упрямый жировой валик внизу живота, который не меняется от тренировок",
        "Растяжки или рубец после кесарева сечения, расположенные в коже, которая всё равно будет удалена"
      ],
      "note": "Абдоминопластика не лечит ожирение и не заменяет снижение веса. Если вы планируете беременность или ожидаете большую потерю веса, обычно лучше подождать: результат рассчитан на длительный срок."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Техника выбирается на консультации, исходя из состояния кожи, мышечного слоя и расположения рубца, а не по одной фотографии.",
      "items": [
        {
          "name": "Полная абдоминопластика",
          "text": "Горизонтальный разрез низко на животе, кожа мобилизуется до рёбер, прямые мышцы живота ушиваются по средней линии, излишки кожи удаляются. Пупок перемещается. Подходит при дряблости кожи и выше, и ниже пупка."
        },
        {
          "name": "Мини-абдоминопластика",
          "text": "Более короткий разрез и более быстрое восстановление — при дряблости, ограниченной нижней частью живота. Пупок обычно остаётся на месте, подтяжка мышц ограничена."
        },
        {
          "name": "Расширенная абдоминопластика",
          "text": "Та же операция, что и полная, но продолженная вокруг боков — для кожи, которая свисает и по сторонам. Часто сочетается с липосакцией талии."
        },
        {
          "name": "Пликация мышц (ушивание диастаза)",
          "text": "Если прямые мышцы разошлись — что часто бывает после беременности — их ушивают обратно к средней линии. Именно это меняет профиль живота, а не только кожа."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Фотографии, сбор анамнеза и откровенный разговор о рубцах, сроках восстановления и о том, что операция может и чего не может. Анализы крови и, при необходимости, УЗИ или заключение кардиолога назначаются до согласования даты."
        },
        {
          "name": "Подготовка",
          "text": "Курение прекращают минимум за три-четыре недели до операции, антикоагулянты и некоторые добавки отменяют примерно за десять дней, а есть и пить нельзя шесть-восемь часов. Договоритесь, кто встретит вас и поможет дома в первую неделю."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом, обычно от двух до четырёх часов. Дренаж часто оставляют на несколько дней. Большинство пациентов остаются в стационаре на одну-две ночи, компрессионное бельё подбирают до выписки."
        },
        {
          "name": "Первые две недели",
          "text": "Ходить можно с первого дня, на короткие расстояния, держа спину прямо. Компрессионное бельё носят днём и ночью. Отёк достигает максимума примерно на третий-пятый день, затем спадает; первый душ и снятие дренажа назначают в клинике."
        },
        {
          "name": "С третьей по шестую неделю",
          "text": "К офисной работе обычно можно вернуться через две-три недели. Спортзал, бассейн и подъём тяжестей откладывают примерно до шестой недели, когда хирург подтвердит, что ткани зажили."
        },
        {
          "name": "Рубец в течение года",
          "text": "В первые месяцы рубец красный и плотный, затем бледнеет и уплощается — этот процесс продолжается от двенадцати до восемнадцати месяцев. Он расположен низко, в линии белья."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Любая операция несёт риски, и о них стоит узнать до решения, а не после.",
      "items": [
        "Серома — скопление жидкости под кожей; самое частое осложнение, обычно её удаляют в клинике",
        "Инфекция или замедленное заживление раны, что более вероятно у курящих",
        "Широкий или выступающий рубец, который можно скорректировать позже, но нельзя устранить полностью",
        "Онемение вокруг рубца и пупка, обычно улучшающееся в течение месяцев",
        "Асимметрия или контур, требующий небольшой коррекции (примерно у одного из десяти пациентов)",
        "Кровотечение, гематомы и, редко, тромбоз — их предупреждают ранней ходьбой и компрессией"
      ],
      "note": "Сообщите на консультации о курении, диабете, приёме антикоагулянтов и любых перенесённых операциях на животе. Каждый из этих пунктов меняет план, а их сокрытие — самый быстрый путь к осложнённому восстановлению."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это больно?",
          "a": "Первые два-три дня скорее дискомфорт, чем боль: ощущение стянутости и болезненности по всему животу. Обычные обезболивающие справляются, и большинство пациентов ходят и едят нормально ещё до выписки."
        },
        {
          "q": "Будет ли виден рубец?",
          "a": "Рубец есть, и он остаётся навсегда. Он проходит низко, по линии белья, и бледнеет в течение двенадцати-восемнадцати месяцев. То, как он заживает, зависит от вашей кожи, от отказа от курения и от соблюдения правил ухода за раной."
        },
        {
          "q": "Можно ли рожать после операции?",
          "a": "Обычно да, но во время беременности живот снова растянется, и часть результата может быть утрачена. Поэтому многие хирурги советуют сначала завершить планирование детей."
        },
        {
          "q": "Можно ли сочетать с липосакцией?",
          "a": "Часто да — липосакцию боков или талии нередко добавляют, чтобы оформить переход. Безопасно ли это в вашем случае, зависит от зоны и длительности операции, и это решение хирурга."
        },
        {
          "q": "Сколько веса я потеряю?",
          "a": "Некоторое количество, но дело не в этом. Операция меняет форму живота. Если ваша цель — снижение веса, правильной отправной точкой будет консультация по бариатрии, а не абдоминопластика."
        },
        {
          "q": "Сколько это стоит?",
          "a": "Цена зависит от техники, клиники, длительности пребывания и от того, нужно ли ушивать мышцы, поэтому её называют после обследования, а не до него. В стоимость входят операция, анестезия, пребывание в стационаре, компрессионное бельё и контрольные визиты."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Их просмотрит хирург, и координатор вернётся к вам с планом, датой и письменным расчётом стоимости — без обязательств и без давления.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Абдоминопластика в Стамбуле | Platinya",
    "seoDesc": "Подтяжка живота в Стамбуле: операция 2–4 часа, 1–2 ночи в стационаре, возвращение к офисной работе через 2–3 недели. Показания и риски."
  },
  "/hair-transplant": {
    "title": "Пересадка волос в Стамбуле (FUE)",
    "eyebrow": "Восстановление волос",
    "lead": "Фолликулы перемещают с затылка — из зоны, где они устойчивы к выпадению — в участки, где волосы поредели. В результате там растут ваши собственные волосы, которых больше не было.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по пересадке волос в Platinya Clinic",
    "stats": [
      {
        "value": "6–9 ч",
        "label": "Длительность процедуры"
      },
      {
        "value": "1 день",
        "label": "В клинике"
      },
      {
        "value": "12–18 месяцев",
        "label": "Окончательный результат"
      }
    ],
    "candidate": {
      "heading": "Кому подходит пересадка",
      "intro": "Ограничивает не то, сколько волос потеряно, а то, сколько донорских волос есть на затылке и по бокам и насколько стабильно протекает выпадение.",
      "items": [
        "Выпадение стабильно примерно в течение года, а не ускоряется неделя за неделей",
        "Достаточная плотность донорской зоны для того числа графтов, которое нужно облысевшей области",
        "Отступающая линия роста волос, поредение в области висков или на макушке",
        "Реалистичные ожидания: плотность улучшается, но облысевшая зона никогда не станет такой, как в юности"
      ],
      "note": "Если выпадение продолжается, сначала его лечат медикаментозно — это защищает результат. Пересадка перемещает волосы, но не останавливает поредение тех волос, которые у вас ещё есть."
    },
    "techniques": {
      "heading": "Как забирают и пересаживают волосы",
      "intro": "Метод выбирают по плотности донорской зоны, размеру области и причёске, которую вы хотите сохранить.",
      "items": [
        {
          "name": "FUE — извлечение фолликулярных единиц",
          "text": "Отдельные фолликулы извлекают микропанчем и пересаживают. Полоса кожи не иссекается, поэтому линейного рубца нет; обратная сторона — донорскую зону сбривают, а заживление занимает несколько дней."
        },
        {
          "name": "DHI — прямая имплантация волос",
          "text": "Фолликулы помещают одноразовой ручкой-имплантером, что позволяет точно контролировать угол и глубину в линии роста волос. Процедура медленнее, поэтому графтов за сеанс меньше."
        },
        {
          "name": "Дизайн линии роста волос",
          "text": "Линию рисуют вместе с вами, сидя и стоя, до любых разрезов: она должна выдержать старение и дальнейшее выпадение, поэтому её располагают скорее консервативно, чем низко."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до окончательного результата",
      "steps": [
        {
          "name": "Обследование",
          "text": "Измеряют плотность донорской зоны, проектируют линию роста волос и назначают анализы крови. Фотографии делают с пяти ракурсов для последующего сравнения."
        },
        {
          "name": "День процедуры",
          "text": "Местная анестезия с лёгкой седацией; вы в сознании и можете есть. Сеанс длинный — от шести до девяти часов — и прерывается короткими паузами."
        },
        {
          "name": "Первые десять дней",
          "text": "Образуются небольшие корочки, которые со второго дня осторожно смывают. Отёк в области лба обычен и спадает в течение недели."
        },
        {
          "name": "Недели 3–12",
          "text": "Большая часть пересаженных волос выпадает — это ожидаемо и не означает неудачи. Новый рост начинается примерно на третьем месяце."
        },
        {
          "name": "С двенадцатого месяца",
          "text": "Плотность и толщина продолжают улучшаться до 12–18 месяцев. Второй сеанс для добавления плотности, если он нужен, планируют не раньше чем через 12 месяцев."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Пересадка — настоящая операция с настоящими ограничениями. О них стоит знать до записи.",
      "items": [
        "Отёк, покраснение и корочки в первую неделю, а также временное онемение кожи головы",
        "Приживаемость фолликулов никогда не составляет 100%; часть графтов не приживается",
        "Неравномерное или редкое покрытие, если запланированное число графтов не обеспечено донорской зоной",
        "Фолликулит — небольшие воспалённые элементы в зоне пересадки, обычно поддаются лечению",
        "Неестественная линия роста волос, если дизайн слишком низкий или слишком плотный для донорской зоны"
      ],
      "note": "Выбирайте план по числу графтов и качеству донорской зоны, а не по самой низкой цене: дешёвый сеанс, который истощает донорскую зону, отменить нельзя."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это больно?",
          "a": "Инъекции жгут несколько секунд, затем кожа головы онемевает и процедура скорее утомительна, чем болезненна. Первая ночь чувствительная, дискомфорт снимается обычными обезболивающими."
        },
        {
          "q": "Останется ли рубец?",
          "a": "FUE оставляет в донорской зоне крошечные круглые следы, которые при обычной длине волос почти незаметны. Полосный метод оставляет тонкую линию на затылке."
        },
        {
          "q": "Когда можно вернуться к работе?",
          "a": "К офисной работе — через два-три дня, когда спадёт отёк. Тяжёлые тренировки, сауна и бассейн — примерно через две недели."
        },
        {
          "q": "Держатся ли новые волосы?",
          "a": "Пересаженные фолликулы сохраняют свойства донорской зоны и обычно остаются навсегда. Волосы вокруг них могут продолжать редеть, поэтому медикаментозную поддержку часто продолжают."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Снимков линии роста волос, макушки и донорской зоны достаточно, чтобы сказать, разумна ли пересадка, сколько примерно нужно графтов и сколько это будет стоить.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра кожи головы и изучения анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Пересадка волос в Стамбуле (FUE) | Platinya",
    "seoDesc": "Пересадка волос методом FUE в Стамбуле: процедура 6–9 часов, один день в клинике, окончательный результат через 12–18 месяцев. Показания и риски."
  },
  "/sapphire-hair-transplant": {
    "title": "Пересадка волос Sapphire FUE в Стамбуле",
    "eyebrow": "Восстановление волос",
    "lead": "Sapphire FUE — то же извлечение фолликулярных единиц, что и при стандартном FUE, но каналы для графтов формируют сапфировыми лезвиями вместо стальных. Разница в разрезах, а не в фолликулах.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Планирование пересадки волос Sapphire FUE в Platinya Clinic",
    "stats": [
      {
        "value": "6–8 ч",
        "label": "Длительность процедуры"
      },
      {
        "value": "1 день",
        "label": "В клинике"
      },
      {
        "value": "10–14 дней",
        "label": "Корочки сходят"
      }
    ],
    "candidate": {
      "heading": "Кому подходит пересадка",
      "intro": "Сапфир — это техника, а не критерий отбора: действуют те же правила, что и при любой пересадке — стабильное выпадение и достаточный объём донорских волос.",
      "items": [
        "Стабильное выпадение волос и здоровая донорская зона на затылке и по бокам",
        "Поредение в области линии роста, висков или макушки, с которым не справилось только лечение",
        "Кожа без активной инфекции, экземы или псориаза в зоне пересадки",
        "Понимание, что лезвие влияет на заживление, а не на число графтов, которое можно позволить"
      ],
      "note": "Клиники, которые рекламируют сапфир как гарантию более густых волос, переоценивают значение инструмента. Приживаемость графтов зависит от того, как обращаются с фолликулами, а не от лезвия."
    },
    "techniques": {
      "heading": "Что меняет сапфировое лезвие",
      "intro": "Та же операция, но с другой режущей кромкой и другим набором компромиссов.",
      "items": [
        {
          "name": "Более узкие каналы",
          "text": "Сапфировые лезвия делают более тонкий разрез, чем стальные, поэтому ткани раздвигаются, а не разрываются. Меньшие отверстия означают меньше корочек и, у большинства пациентов, более быстрое заживление."
        },
        {
          "name": "Более плотная посадка графта",
          "text": "Графт, который сидит в канале плотно, меньше смещается в первые дни. Это особенно важно в линии роста волос, где направление и угол видны."
        },
        {
          "name": "Чего это не меняет",
          "text": "Это не увеличивает число графтов, которое может дать донорская зона, и не заменяет план: плотность, дизайн линии роста и то, как команда обращается с фолликулами, определяют результат."
        }
      ]
    },
    "journey": {
      "heading": "День процедуры, час за часом",
      "steps": [
        {
          "name": "Дизайн и бритьё",
          "text": "Линию роста волос рисуют и согласовывают до любых разрезов. Донорскую зону коротко подстригают; зону пересадки в большинстве случаев сбривают."
        },
        {
          "name": "Анестезия",
          "text": "Инъекции местного анестетика с лёгкой седацией. Дискомфорт ограничен первыми минутами."
        },
        {
          "name": "Забор и каналы",
          "text": "Фолликулы извлекают, держат в охлаждённом растворе, а сапфировые каналы формируют под тем углом, который нужен линии роста."
        },
        {
          "name": "Имплантация",
          "text": "Графты помещают один за другим. На длинных сеансах команда работает посменно, чтобы качество работы с материалом оставалось неизменным."
        },
        {
          "name": "Заживление",
          "text": "Мелкие корочки сходят за 10–14 дней. Пересаженные волосы выпадают с третьей недели, затем с третьего месяца начинается рост."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Любая пересадка несёт одни и те же основные риски, каким бы лезвием она ни выполнялась.",
      "items": [
        "Отёк, болезненность и временное онемение в донорской зоне и зоне пересадки",
        "Корочки и покраснение, которые держатся дольше ожидаемого при чувствительной коже",
        "Часть графтов не приживается, поэтому иногда требуется второй сеанс",
        "Фолликулит или небольшие кисты вокруг новых графтов в первые недели",
        "Линия роста волос, которая выглядит слишком прямой или слишком плотной, если дизайн не был консервативным"
      ],
      "note": "Спросите, сколько графтов запланировано, кто формирует каналы и кто выполняет имплантацию: эти ответы скажут о результате больше, чем слово «сапфир»."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сапфир лучше стального FUE?",
          "a": "Заживление немного быстрее и корочек меньше. Независимых данных о том, что волос вырастает больше, мало; обращение хирурга с графтами важнее."
        },
        {
          "q": "Это больнее?",
          "a": "Нет. Анестезия та же, а лезвие применяется на уже онемевшей коже."
        },
        {
          "q": "Как быстро исчезают корочки?",
          "a": "Обычно в течение 10–14 дней при осторожном мытье со второго дня."
        },
        {
          "q": "Достаточно одного сеанса?",
          "a": "Многим пациентам да. Большие облысевшие области или низкая плотность донорской зоны могут потребовать второго сеанса через 12 месяцев, чтобы достичь запланированной плотности."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Мы честно скажем, даёт ли Sapphire FUE что-то дополнительное в вашем случае и каким будет число графтов.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания определяются после осмотра; результаты у разных пациентов различаются.",
    "seoTitle": "Пересадка волос Sapphire FUE в Стамбуле | Platinya",
    "seoDesc": "Sapphire FUE в Стамбуле: процедура 6–8 часов, корочки сходят за 10–14 дней. Чем сапфировое лезвие отличается от стального и какие есть риски."
  },
  "/hair-implant-hybrid": {
    "title": "Гибридная пересадка волос (FUE + FUT) в Стамбуле",
    "eyebrow": "Восстановление волос",
    "lead": "Гибридный сеанс использует оба способа забора волос — тонкую полосу с затылка и отдельные фолликулярные единицы — в одной операции, когда один метод не может дать нужное число графтов для облысевшей области.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Сравнение техник гибридной пересадки волос в Platinya Clinic",
    "stats": [
      {
        "value": "1 сеанс",
        "label": "Две техники"
      },
      {
        "value": "+30–50%",
        "label": "Графтов по сравнению с FUE"
      },
      {
        "value": "12 месяцев",
        "label": "До оценки результата"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Гибрид — это задача снабжения, решаемая двумя инструментами: он существует для больших облысевших областей и донорской зоны, недостаточно плотной, чтобы дать всё только забором.",
      "items": [
        "Выраженное выпадение — Norwood 5–6 — когда один сеанс FUE оставил бы макушку редкой",
        "Хорошая плотность в зоне полосы, но ограниченное число фолликулярных единиц для извлечения",
        "Предыдущий сеанс FUE, после которого доступные донорские участки исчерпаны",
        "Готовность принять тонкий линейный рубец в обмен на существенно большее число графтов"
      ],
      "note": "Больше графтов не значит автоматически лучше. Гибрид имеет смысл, когда план действительно требует дополнительных чисел; для небольших зон одна техника проще и заживает быстрее."
    },
    "techniques": {
      "heading": "Как две половины работают вместе",
      "intro": "Сначала забирают полосу, затем забор дополняет остальную часть плана — одна анестезия, один день.",
      "items": [
        {
          "name": "Полоса (FUT)",
          "text": "С затылка иссекают узкий эллипс кожи, ушивают послойно и разделяют на отдельные графты под микроскопом. Это самый плотный источник графтов на квадратный сантиметр."
        },
        {
          "name": "Забор (FUE)",
          "text": "Затем фолликулы извлекают по одному с боков, добавляя графты без второй линии рубца и, что важно, не истончая зону ушивания полосы."
        },
        {
          "name": "Почему не сделать просто больше FUE",
          "text": "Потому что избыточный забор оставляет донорскую зону неравномерной и закрывает путь к любому будущему сеансу. Гибрид распределяет нагрузку между двумя донорскими зонами."
        }
      ]
    },
    "journey": {
      "heading": "От планирования до окончательного результата",
      "steps": [
        {
          "name": "Расчёт графтов",
          "text": "Плотность донорской зоны в области полосы и в области забора измеряют отдельно, и число графтов, которое может дать каждая, суммируют. Эта сумма и задаёт план."
        },
        {
          "name": "День операции",
          "text": "Забор полосы занимает около часа; команда разделяет материал, пока продолжается извлечение. Для большого сеанса рассчитывайте в общей сложности на восемь-десять часов."
        },
        {
          "name": "Первые две недели",
          "text": "Линию полосы ушивают швами или скобами, которые снимают примерно на 10–14-й день. Корочки в зоне пересадки сходят в тот же период."
        },
        {
          "name": "Месяцы 1–3",
          "text": "Пересаженные волосы выпадают, затем начинается рост. Линейный рубец бледнеет от красного к светлому."
        },
        {
          "name": "Месяцы 12–18",
          "text": "Окончательная плотность. При обычной длине волос рубец от полосы обычно скрыт окружающими волосами; очень короткие стрижки его покажут."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Гибрид несёт риски обеих техник одновременно.",
      "items": [
        "Постоянный линейный рубец на затылке, скрытый волосами при обычной длине",
        "Натяжение или растяжение рубца, если ушивание выполнено под натяжением или заживление плохое",
        "Временное онемение выше рубца, которое может проходить месяцами",
        "Обычные риски любой пересадки: отёк, фолликулит, частичная потеря графтов",
        "Долгий сеанс — усталость сказывается и на пациенте, и на команде, поэтому день планируют по этапам"
      ],
      "note": "Спросите, кто ушивает полосу и сколько гибридных сеансов клиника выполняет в месяц. Именно качество ушивания пациенты оценивают спустя годы."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько графтов даёт гибрид?",
          "a": "Обычно 4 000–6 000 за один сеанс при подходящей донорской зоне, против примерно 2 500–3 500 при одном FUE. Точная цифра измеряется, а не обещается."
        },
        {
          "q": "Будет ли виден рубец?",
          "a": "При обычной длине волос обычно нет. При бритой голове или очень коротком фейде он виден как светлая линия, и с этим нужно согласиться до записи."
        },
        {
          "q": "Это болезненнее, чем FUE?",
          "a": "Первые две ночи ощущаются как более сильное натяжение из-за ушивания. Затем обе стороны чувствуются похоже; зону полосы часто описывают как болезненность после ушиба."
        },
        {
          "q": "Можно ли позже сделать FUE?",
          "a": "Да, если зоны забора не исчерпаны. Именно поэтому план распределяет донорскую зону на будущие сеансы, а не расходует её всю сразу."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Мы измерим обе донорские зоны и скажем, даёт ли гибрид что-то сверх одной техники.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания и число графтов определяются после осмотра; результаты различаются.",
    "seoTitle": "Гибридная пересадка волос (FUE + FUT) | Platinya",
    "seoDesc": "Гибридная пересадка волос в Стамбуле: полоса FUT и забор FUE за один сеанс, 4 000–6 000 графтов. Кому подходит и какие есть риски."
  },
  "/hair-transplant-for-women": {
    "title": "Пересадка волос для женщин в Стамбуле",
    "eyebrow": "Восстановление волос",
    "lead": "Женское выпадение волос — обычно диффузное поредение, а не облысевший участок, и у него часто есть причина, которую можно лечить. Пересадку рассматривают после исключения этих причин, и она отличается от мужской операции.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по выпадению волос у женщин в Platinya Clinic",
    "stats": [
      {
        "value": "1 день",
        "label": "В клинике"
      },
      {
        "value": "Без бритья",
        "label": "В большинстве случаев"
      },
      {
        "value": "12 месяцев",
        "label": "До оценки плотности"
      }
    ],
    "candidate": {
      "heading": "Кому это помогает, а кому нет",
      "intro": "У женщин первый вопрос не «сколько графтов», а «почему волосы редеют». Анализы крови предшествуют любому хирургическому плану.",
      "items": [
        "Поредение, которое продолжается, несмотря на нормальные показатели железа, щитовидной железы, витамина D и гормонов",
        "Локальное поредение в области пробора, висков или по передней линии роста",
        "Рубцовые изменения после натяжения, ожогов, операций или алопеции, стабильной в течение года",
        "Потеря волос на бровях или по линии роста после чрезмерного выщипывания или травмы при перманентном макияже"
      ],
      "note": "Диффузное выпадение по всей коже головы — телогеновое выпадение — обычно обратимо и не лечится операцией. Сначала исключают дефицит железа, заболевания щитовидной железы, СПКЯ и послеродовое выпадение, потому что пересадка в зону активного выпадения расходует графты впустую."
    },
    "techniques": {
      "heading": "Чем женская операция отличается",
      "intro": "Принцип тот же, практика — нет: меньше бритья, меньше графтов, больше внимания к тому, как ложатся волосы.",
      "items": [
        {
          "name": "Частичное бритьё или без него",
          "text": "Фолликулы можно извлечь из узкой полосы, которую закрывают окружающие волосы, поэтому донорскую зону не обязательно сбривать. Процедура медленнее, поэтому сеансы меньше."
        },
        {
          "name": "Плотность, а не покрытие",
          "text": "При женском выпадении речь о добавлении плотности между существующими волосами, а не о восстановлении линии роста. Графты размещают между собственными фолликулами под углом, повторяющим естественное падение волос."
        },
        {
          "name": "Сочетание с медикаментозным лечением",
          "text": "Миноксидил, а в некоторых случаях назначенные препараты, обычно продолжают до и после операции: пересадка добавляет плотность, но не останавливает сам процесс."
        }
      ]
    },
    "journey": {
      "heading": "С первой консультации",
      "steps": [
        {
          "name": "Сначала причины",
          "text": "Анализы крови, история характера выпадения и трихоскопия. Если найдена обратимая причина, её лечат, прежде чем снова обсуждать операцию."
        },
        {
          "name": "Планирование плотности",
          "text": "Область размечают, а число графтов намеренно держат умеренным: избыточно плотная посадка в истончённой женской коже головы может повредить волосы, которые ещё есть."
        },
        {
          "name": "День операции",
          "text": "Местная анестезия; сеанс обычно длится от четырёх до шести часов. Большинство пациенток в тот же день возвращаются домой."
        },
        {
          "name": "Первый месяц",
          "text": "Отёк и болезненность проходят за несколько дней. Пересаженные волосы выпадают с третьей недели — это ожидаемо."
        },
        {
          "name": "Месяцы 6–12",
          "text": "Плотность нарастает постепенно. По мере созревания цвет и текстура волос совпадают с окружающими."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Риски стандартные, но два из них важнее для женщин.",
      "items": [
        "Шоковое выпадение волос вокруг графтов в первые недели — обычно временное, но пугающее",
        "Слишком плотная посадка, повреждающая собственные фолликулы в истончённой коже головы",
        "Неравномерный результат, если основная причина была активна во время операции",
        "Фолликулит, корочки и временное онемение",
        "Заметное изменение текстуры волос в зоне пересадки у части пациенток"
      ],
      "note": "Клиника, которая предлагает операцию, не спросив о железе, щитовидной железе и гормонах, пропускает именно то, что определяет, стоило ли делать операцию."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Придётся ли сбривать голову?",
          "a": "Обычно нет. В большинстве женских сеансов используют частично выбритую донорскую полосу, которую закрывают окружающие волосы, либо не бреют вовсе, но забор идёт медленнее."
        },
        {
          "q": "Можно ли потом укладывать волосы как раньше?",
          "a": "Примерно через десять дней — да, осторожно. Окрашивание и завивка — через шесть-восемь недель, а тугие хвосты и косы в первый месяц не делают."
        },
        {
          "q": "Достаточно одного сеанса?",
          "a": "При диффузном поредении часто планируют два сеанса с интервалом в двенадцать месяцев, потому что постепенное добавление плотности сохраняет существующие волосы."
        },
        {
          "q": "А если причина гормональная?",
          "a": "Тогда гормональное лечение — основа, а операция лишь дополнение. Операция при активном выпадении даёт результат, который редеет вокруг графтов."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Снимков пробора, линии роста волос и донорской зоны, а также свежих результатов анализов достаточно для первого мнения — включая ответ, нужна ли операция вообще.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Женское выпадение волос требует диагноза до любого хирургического плана; результаты различаются.",
    "seoTitle": "Пересадка волос для женщин в Стамбуле | Platinya",
    "seoDesc": "Пересадка волос для женщин в Стамбуле: чаще без бритья, один день в клинике, оценка плотности через 12 месяцев. Сначала ищут причину выпадения."
  },
  "/eyebrow-transplant": {
    "title": "Пересадка бровей в Стамбуле",
    "eyebrow": "Восстановление волос",
    "lead": "Отдельные волосы забирают с кожи головы и помещают в бровь под тем углом, под которым растёт каждый волос, чтобы восстановить бровь, поредевшую от выщипывания, рубцов или наследственности.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по пересадке бровей в Platinya Clinic",
    "stats": [
      {
        "value": "3–4 ч",
        "label": "Длительность процедуры"
      },
      {
        "value": "200–400",
        "label": "Графтов на бровь"
      },
      {
        "value": "6–9 месяцев",
        "label": "Окончательная форма"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Брови — самая заметная пересадка на лице, поэтому сначала нужно решить, есть ли ещё форма, которую можно восстановить.",
      "items": [
        "Поредение после многолетнего выщипывания, когда фолликулы перестали восстанавливаться",
        "Рубцы после ожогов, порезов или удаления перманентного макияжа",
        "Естественно редкие или асимметричные брови, а также потеря после химиотерапии, не восстановившаяся самостоятельно",
        "Здоровая кожа без активной экземы, псориаза или инфекции в области бровей"
      ],
      "note": "Если бровь редкая из-за заболевания щитовидной железы или дефицита питательных веществ, сначала лечат это. Волосы, взятые с кожи головы, растут как волосы головы, поэтому их нужно подстригать — это постоянный уход, и это стоит понять до записи."
    },
    "techniques": {
      "heading": "Как это делается",
      "intro": "Точность, а не объём: несколько сотен одиночных волос, каждый под своим углом.",
      "items": [
        {
          "name": "Графты из одного волоса",
          "text": "Используют только фолликулярные единицы с одним и двумя волосами. Многоволосные графты в брови выглядят кучно, поэтому донорский участок подбирают по тонким одиночным волосам — часто за ухом."
        },
        {
          "name": "Угол и направление",
          "text": "В начале брови волосы растут вверх и наружу, к хвосту становятся более плоскими. Каждый графт помещают отдельно, следуя этой схеме, иначе результат выглядит неестественно."
        },
        {
          "name": "Плотность в два прохода",
          "text": "Консервативный первый проход защищает кровоснабжение тонкой кожи брови; второй сеанс через 9–12 месяцев добавляет плотность там, где она нужна, вместо избыточной посадки сразу."
        }
      ]
    },
    "journey": {
      "heading": "От дизайна до окончательной формы",
      "steps": [
        {
          "name": "Дизайн на лице",
          "text": "Бровь рисуют, когда вы сидите, сверяют со второй стороной и пропорциями лица и согласовывают до забора любого графта."
        },
        {
          "name": "Операция",
          "text": "Местная анестезия. Забор из донорской зоны, затем имплантация тонкими иглами. Обе брови — от трёх до четырёх часов."
        },
        {
          "name": "Первые десять дней",
          "text": "Небольшие корочки; макияж на область не наносят, не трут, не спят лицом вниз. Отёк спадает за неделю."
        },
        {
          "name": "Недели 3–8",
          "text": "Большая часть графтов выпадает, это нормально. Какое-то время бровь выглядит реже, чем в день операции."
        },
        {
          "name": "Месяцы 6–9",
          "text": "Новые волосы брови приживаются. С этого момента они растут длинными, и их подстригают маленькими ножницами каждые несколько недель."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "На лице даже небольшие технические ошибки заметны. Вот о чём стоит поговорить.",
      "items": [
        "Неестественное направление или слишком плотный участок, выглядящий как пучок",
        "Асимметрия между бровями — идеальная симметрия недостижима",
        "Потеря графтов в рубцовой коже, где кровоснабжение слабее",
        "Фолликулит или небольшие кисты в первые недели",
        "Волосы, которые растут быстрее и длиннее исходных волос брови и требуют регулярной стрижки"
      ],
      "note": "Просите показать зажившие результаты через шесть месяцев и более, а не на следующий день после операции. Направление и плотность становятся видны только когда волосы улягутся."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Будет ли это выглядеть естественно?",
          "a": "Если используют одиночные волосы и ставят их под правильным углом — да, на расстоянии разговора это читается как обычная бровь. Риск — избыточная плотность, поэтому первый проход консервативный."
        },
        {
          "q": "Можно ли их потом корректировать?",
          "a": "Да, но осторожно. Выщипывания и воска избегают; пересаженные брови поддерживают в форме стрижкой ножницами."
        },
        {
          "q": "Когда можно наносить макияж?",
          "a": "Примерно через 7–10 дней, когда корочки сойдут и кожа закроется."
        },
        {
          "q": "Нужен ли второй сеанс?",
          "a": "Часто да, для плотности, и его планируют через 9–12 месяцев. Первый сеанс создаёт форму, второй её наполняет."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Крупного снимка каждой брови, прямо и под углом, достаточно, чтобы оценить, что можно восстановить.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания для бровей оценивают при осмотре; результаты у разных пациентов различаются.",
    "seoTitle": "Пересадка бровей в Стамбуле | Platinya",
    "seoDesc": "Пересадка бровей в Стамбуле: процедура 3–4 часа, 200–400 графтов на бровь, окончательная форма через 6–9 месяцев. Показания и риски."
  },
  "/hollywood-smile": {
    "title": "Голливудская улыбка в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Голливудская улыбка — это план, а не одна процедура: форма, цвет и пропорции передних зубов проектируются вместе, а затем воплощаются винирами, коронками и — при неровном крае десны — контурированием дёсен. Большинство планов завершают за пять-семь дней.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по голливудской улыбке в Platinya Clinic",
    "stats": [
      {
        "value": "5–7 дней",
        "label": "Обычный план"
      },
      {
        "value": "8–20",
        "label": "Зубов обычно в работе"
      },
      {
        "value": "10–15 лет",
        "label": "Срок службы при уходе"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Дизайн должен соответствовать лицу и прикусу. Улыбка, которая хорошо выглядит на фотографии, может не подойти человеку, который скрипит зубами, или губам, сильно открывающим десну.",
      "items": [
        "Передние зубы со сколами, стёртыми краями или изменением цвета, которое не уберёт отбеливание",
        "Небольшие промежутки или повёрнутые, слегка неровные зубы — но не настолько, чтобы требовалась ортодонтия",
        "Старые коронки или крупные пломбы на передних зубах, которые больше не совпадают по цвету с соседними",
        "Неровный край десны, когда одни зубы кажутся длиннее других"
      ],
      "note": "Сначала зубы и дёсны должны быть здоровы. Активный кариес, заболевание дёсен или нестабильный прикус лечат до изготовления любого винира; иначе новая работа строится на том, что всё ещё меняется."
    },
    "techniques": {
      "heading": "Как строится улыбка",
      "intro": "Состав работы определяется тем, сколько осталось зуба, сколько эмали можно сохранить и насколько серьёзных изменений вы действительно хотите.",
      "items": [
        {
          "name": "Цифровой дизайн и примерочная улыбка",
          "text": "По фотографиям и внутриротовому скану улыбку проектируют на экране, беря пропорции от вашего лица, а не из шаблона. Дизайн печатают в виде макета и временно фиксируют поверх собственных зубов, чтобы вы могли увидеть его, поговорить с ним и изменить до любых необратимых действий."
        },
        {
          "name": "Виниры и коронки",
          "text": "Виниры — тонкие керамические накладки, которые фиксируют на передней поверхности интактных зубов, почти без препарирования. Коронки закрывают зуб целиком и применяются там, где он сильно пломбирован, депульпирован или разрушен. В большинстве случаев эти два решения сочетают: виниры в средней зоне, коронки там, где зубу нужна опора."
        },
        {
          "name": "Контурирование дёсен",
          "text": "Неровный край десны корректируют лазером или тонким лезвием. Если сами зубы короткие из-за низкого расположения десны и кости, требуется удлинение коронковой части — небольшой хирургический этап, который добавляет к плану недели, а не дни."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до окончательной улыбки",
      "steps": [
        {
          "name": "Обследование и дизайн",
          "text": "Осмотр, снимки, фотографии и запись цвета. Прикус проверяют на стираемость и скрип. Дизайн показывают вместе с его ограничениями: какие зубы, сколько эмали и насколько белый оттенок будет достоверным для вашей кожи."
        },
        {
          "name": "Примерочная улыбка",
          "text": "Макет фиксируют поверх зубов на день или два. Это момент, когда стоит быть требовательным — длина, симметрия, вид при разговоре, — потому что всё ещё обратимо."
        },
        {
          "name": "Препарирование",
          "text": "Под местной анестезией эмаль сошлифовывают примерно на толщину будущей керамики, снимают слепки или скан, и в тот же день устанавливают временные конструкции. Зубы обычно чувствительны несколько дней."
        },
        {
          "name": "Примерка",
          "text": "Керамика возвращается из лаборатории, и до фиксации проверяют посадку, цвет и прикус. Небольшие коррекции на этом этапе нормальны; переделка добавляет дни."
        },
        {
          "name": "Фиксация и контроль",
          "text": "Конструкции фиксируют, прикус уточняют, а при скрипе изготавливают ночную каппу. Контроль через одну-две недели, затем регулярная профессиональная гигиена: именно состояние краёв определяет, сколько прослужат эти реставрации."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Это не одна операция, а серия необратимых решений. Вот о чём стоит знать до препарирования первого зуба.",
      "items": [
        "Эмаль, снятая под виниры, не восстанавливается; этим зубам всегда будет нужна реставрация",
        "Чувствительность к горячему и холодному в течение дней или недель, иногда дольше",
        "Сколы или отклеивание, чаще у тех, кто скрипит зубами или грызёт ногти",
        "Оттенок, который выглядит слишком плотным или слишком однородным, особенно когда обрабатывают много зубов сразу",
        "Воспаление или рецессия десны по краям, где становится трудно чистить"
      ],
      "note": "Обычное разочарование вызывает не керамика, а план: слишком много зубов, слишком белый оттенок или несбалансированный прикус, из-за которого передние зубы несут нагрузку, для которой не предназначены."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько это занимает времени?",
          "a": "Пять-семь дней в клинике при несложном случае: два визита — препарирование и фиксация, а между ними работает лаборатория. Если нужны операции на дёснах, реконструкция прикуса или удаление зубов, план растягивается на недели или месяцы."
        },
        {
          "q": "Будет ли это выглядеть естественно?",
          "a": "Может, но естественность — это решение, а не значение по умолчанию. Настоящие зубы не одного плоского цвета: у шейки они теплее, край прозрачнее, на поверхности есть текстура. Хороший техник это воспроизводит; очень белый и очень плотный набор читается как искусственный при любой керамике."
        },
        {
          "q": "Нужно ли лечить все зубы?",
          "a": "Обычно восемь-десять верхних зубов — те, что видны при улыбке и разговоре. Нижние часто не трогают, если они не видны. Обработка большего числа, чем видно, добавляет стоимость и потерю эмали, не меняя улыбку."
        },
        {
          "q": "Сколько они служат?",
          "a": "Качественно изготовленные виниры обычно служат десять-пятнадцать лет; коронки — столько же или дольше. Срок определяет не столько керамика, сколько прикус, скрип зубами и то, насколько тщательно очищают края."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии вашей улыбки",
      "text": "Снимка анфас, крупного снимка зубов и снимка с расслабленными губами достаточно для первого мнения о том, что возможно, сколько примерно зубов это затронет и что потребуется.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра зубов, дёсен, прикуса и изучения анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Голливудская улыбка в Стамбуле | Platinya",
    "seoDesc": "Голливудская улыбка в Стамбуле: план на 5–7 дней, обычно 8–20 зубов, срок службы 10–15 лет при уходе. Этапы, материалы и риски."
  },
  "/dental-veneers": {
    "title": "Виниры из керамики E-max в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Винир — тонкая керамическая накладка, зафиксированная на передней поверхности зуба. Цель — изменить форму и цвет, сняв как можно меньше эмали: при минимальном препарировании это примерно 0,3–0,8 мм, и эмаль не восстанавливается.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по керамическим винирам в Platinya Clinic",
    "stats": [
      {
        "value": "2 визита",
        "label": "В клинике"
      },
      {
        "value": "0,3–0,8 мм",
        "label": "Эмали обычно снимают"
      },
      {
        "value": "10 лет и более",
        "label": "Обычный срок службы"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Виниры решают задачи формы, цвета и положения передних зубов. Они не решают проблему прикуса и не выравнивают скученные зубы так, как это делает ортодонтия.",
      "items": [
        "Сколотые, стёртые или слегка повёрнутые передние зубы, когда желаемое изменение косметическое",
        "Изменение цвета изнутри зуба — флюороз, старое тетрациклиновое окрашивание, зуб после лечения каналов, — которое не поднимает отбеливание",
        "Небольшие промежутки и неровные края; одиночный промежуток по средней линии часто удаётся закрыть",
        "Здоровая эмаль: виниру нужна здоровая поверхность, к которой можно приклеиться"
      ],
      "note": "При выраженной скученности обычно лучше сначала ортодонтия: меньше зубов препарируется и результат живёт дольше. Виниры поверх скученных зубов получаются толстыми, глухими и труднодоступными для чистки."
    },
    "techniques": {
      "heading": "Какая керамика и почему",
      "intro": "Материал выбирают по тому, сколько ткани зуба утрачено, сколько эмали можно сохранить и речь идёт об одном зубе или о всей улыбке.",
      "items": [
        {
          "name": "E-max — дисиликат лития",
          "text": "Стандарт для большинства виниров: прессованный или фрезерованный дисиликат лития, фиксируемый на композитный цемент. Достаточно прочен для передних зубов и премоляров, достаточно прозрачен, чтобы вести себя как эмаль, и требует примерно 0,3–0,8 мм сошлифовывания, а не полной коронки."
        },
        {
          "name": "Полевошпатная керамика",
          "text": "Её послойно формирует техник вручную, а не фрезерует станок, поэтому цвет и прозрачность закладываются слоями. Самый достоверный вариант для одного видимого зуба; при этом она тоньше, более требовательна к мастерству и дороже."
        },
        {
          "name": "Композитная реставрация",
          "text": "Композит наращивают прямо на зубе, без снятия эмали, завершают за один визит, и процедура обратима. Он быстрее окрашивается и скалывается — реалистичный срок пять-семь лет, — поэтому подходит для небольших исправлений или пробы формы перед керамикой."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до фиксации виниров",
      "steps": [
        {
          "name": "Обследование",
          "text": "Фотографии, снимки, определение цвета и проверка прикуса. Первый вопрос — не даст ли ортодонтия лучший результат; второй — сколько эмали есть в запасе."
        },
        {
          "name": "Препарирование",
          "text": "Под местной анестезией эмаль сошлифовывают на толщину планируемой керамики, снимают скан и устанавливают временные виниры, чтобы зубы не оставались открытыми и чувствительными."
        },
        {
          "name": "Примерка",
          "text": "Керамику примеряют на водорастворимой пасте до какой-либо фиксации. Посадку, цвет и форму проверяют при дневном свете, а не только под лампой в кабинете."
        },
        {
          "name": "Фиксация",
          "text": "Под коффердамом эмаль протравливают, винир фиксируют на композитный цемент, излишки убирают с краёв и уточняют прикус. Этот этап необратим."
        },
        {
          "name": "Контроль и уход",
          "text": "Осмотр через одну-две недели, ночная каппа при скрипе зубами и инструкции по чистке, включая флосс у края. Виниры ломают ногти, лёд и колпачки ручек."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Процедура небольшая, но обмен необратимый. Вот границы, которые стоит понять до препарирования первого зуба.",
      "items": [
        "Потеря эмали необратима: этому зубу всегда будет нужен винир, коронка или композит",
        "Чувствительность к холодному, иногда неделями, особенно при тонком препарировании",
        "Отклеивание или скол, обычно поддающиеся ремонту, хотя композитный ремонт никогда не совпадает идеально",
        "Один винир трудно подобрать к соседним зубам спустя годы, когда те постарели или изменили цвет",
        "Рецессия десны у края с обнажением границы или воспаление пульпы, если препарирование было слишком агрессивным"
      ],
      "note": "Сильнейший аргумент за щадящее препарирование — не первые пять лет, а третья замена: каждая переделка снимает ещё немного зуба, а запас не бесконечен."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько снимают с зуба?",
          "a": "От 0,3 до 0,8 мм при типичном винире E-max, а иногда не снимают вовсе, если зуб уже стёрт. Величину определяют толщина, нужная керамике для прочности, и то, насколько визуально нужно сместить зуб."
        },
        {
          "q": "Виниры окрашиваются?",
          "a": "Сама керамика не впитывает цвет так, как композит. Меняется край: если стык с зубом обнажён или плохо очищается, он темнеет. Полировка на профилактических визитах сохраняет его чистым."
        },
        {
          "q": "Они будут выглядеть объёмными?",
          "a": "Только если добавить слишком много. Винир может сделать зуб длиннее или шире, но не может сделать его тоньше, чем он уже есть, поэтому выступающему зубу нужно препарирование, а не больше керамики. Это решается на этапе дизайна, а не после фиксации."
        },
        {
          "q": "Сколько они служат?",
          "a": "Десять лет и часто больше для качественно сделанных виниров при хорошем уходе. Неудачи обычно связаны со сколом на режущем крае или краевой протечкой, и то и другое чаще бывает у тех, кто скрипит зубами без ночной каппы."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографию зуба, который хотите изменить",
      "text": "Крупного резкого снимка и вида анфас достаточно, чтобы сказать, что разумнее — винир, композит или ортодонтия, и сколько эмали вам будет стоить препарирование.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра зубов, дёсен, прикуса и изучения анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Виниры E-max в Стамбуле | Platinya",
    "seoDesc": "Керамические виниры E-max в Стамбуле: два визита, сошлифовывание эмали 0,3–0,8 мм, срок службы от 10 лет. Показания и ограничения."
  },
  "/teeth-whitening": {
    "title": "Отбеливание зубов в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Отбеливание меняет цвет собственных зубов с помощью перекиси — в кабинете, в контролируемой концентрации, или дома в индивидуальной каппе за две-четыре недели. Цвет коронок, виниров и пломб оно не меняет, и это ограничение определяет весь план.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Обследование перед отбеливанием зубов в Platinya Clinic",
    "stats": [
      {
        "value": "45–90 мин",
        "label": "Сеанс в кабинете"
      },
      {
        "value": "1–2 сеанса",
        "label": "Обычно достаточно"
      },
      {
        "value": "6–24 месяца",
        "label": "До коррекции"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Большинство здоровых зубов взрослого человека в той или иной степени отвечают на отбеливание. Различаются тип налёта, исходный оттенок и то, где находится пигмент — в эмали или глубже в зубе.",
      "items": [
        "Жёлтые или сероватые собственные зубы, обычно возрастные или от чая, кофе и табака",
        "Пигментация, которая быстро возвращается после профессиональной чистки и полировки",
        "Перед винирами или коронками, чтобы керамику подобрать к более светлому оттенку, а не наоборот",
        "Здоровые дёсны и отсутствие нелеченого кариеса: отбеливание над негерметичной пломбой или обнажённым дентином даёт боль, а не белизну"
      ],
      "note": "Коронки, виниры, композитные пломбы и реставрации не светлеют. Если отбеливать рот с видимыми реставрациями, они могут начать выглядеть темнее на контрасте; либо их меняют позже, либо оттенок подбирают под них. Решение принимают до начала."
    },
    "techniques": {
      "heading": "В кабинете, дома или и так, и так",
      "intro": "Оба подхода используют одну и ту же химию в разных концентрациях. Что подойдёт вам, зависит от того, сколько у вас времени и как реагируют зубы.",
      "items": [
        {
          "name": "Отбеливание в кабинете",
          "text": "Гель с высокой концентрацией перекиси водорода — обычно 25–40% — наносят при изолированных дёснах и отведённых губах, в три-четыре цикла по 10–15 минут. Один визит, самый быстрый результат; чувствительность обычно максимальна на следующий день."
        },
        {
          "name": "Отбеливание в индивидуальных каппах дома",
          "text": "Снимают слепки и изготавливают каппы по размеру. Карбамида пероксид 10–16% носят 30–60 минут в день или более слабый гель — на ночь, в течение двух-четырёх недель. Медленнее и мягче, и результат часто ровнее, потому что гель доходит до всего зубного ряда."
        },
        {
          "name": "Комбинированно",
          "text": "Сеанс в кабинете поднимает базовый оттенок, затем одну-две недели капп дома, чтобы выровнять шейку зуба — обычно самую тёмную часть. К этому плану приходит большинство пациентов."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до окончательного оттенка",
      "steps": [
        {
          "name": "Обследование и чистка",
          "text": "Проверяют кариес, состояние дёсен и имеющиеся реставрации. Сначала снятие камня и полировка: отбеливание не убирает зубной камень, а чистая поверхность — единственная честная отправная точка."
        },
        {
          "name": "Фиксация оттенка",
          "text": "Фотографии и определение оттенка при стандартном освещении, до начала процедуры. Без этого об изменении можно только спорить, а не измерять его."
        },
        {
          "name": "Отбеливание",
          "text": "Либо один сеанс в кабинете с изоляцией дёсен, либо каппы и письменные инструкции. С каппами первые два-три дня показывают, чувствительны ли ваши зубы, и концентрацию геля корректируют."
        },
        {
          "name": "Контроль через две недели",
          "text": "Цвет стабилизируется примерно за две недели, пока зубы восстанавливают минеральный баланс, поэтому окончательный оттенок оценивают тогда, а не в день процедуры, когда зубы всегда выглядят неестественно яркими."
        },
        {
          "name": "Поддержка",
          "text": "Поддерживающие каппы каждые шесть-двадцать четыре месяца и разумные первые 48 часов: без кофе, красного вина, куркумы и курения, пока эмаль наиболее восприимчива."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Отбеливание малорисково, когда его оценивают и ведут под контролем. Большинство проблем возникает, когда нет ни того, ни другого.",
      "items": [
        "Чувствительность во время процедуры и день-два после, иногда дольше; существующая рецессия десны усиливает её",
        "Раздражение или побледнение десны там, где гель попадает на мягкие ткани, — обычно проходит за несколько дней",
        "Слабое изменение или его отсутствие при внутренних пигментациях, на депульпированном зубе или при флюорозе",
        "Реставрации сохраняют исходный оттенок и могут выглядеть темнее, когда зубы вокруг светлеют",
        "Возврат цвета: результат не постоянен, а скорость возврата зависит от питания и курения"
      ],
      "note": "Больше геля не значит белее. Повторные сеансы высокой концентрации без контроля повышают чувствительность и придают эмали меловидный, истончённый вид; инструкции к каппам существуют не просто так."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это повреждает эмаль?",
          "a": "В контролируемых концентрациях — нет: перекись поднимает пигмент, не растворяя измеримый объём ткани зуба, а минеральный состав восстанавливается в последующие дни. Повреждение и стойкая чувствительность появляются при злоупотреблении — частых сеансах высокой концентрации без обследования."
        },
        {
          "q": "Насколько белыми станут мои зубы?",
          "a": "Заранее это обещать нельзя. Лучше всего отвечают жёлтые и возрастные пигментации; серые, тетрациклиновые и флюорозные — слабо, а иногда не отвечают вообще. Большинство пациентов получают несколько оттенков, и честный ответ — диапазон, а не число."
        },
        {
          "q": "Это больно?",
          "a": "Сам гель не болезненный. Чувствительность к холодному и иногда резкая боль у шейки зуба обычны в течение дня-двух — их уменьшают более низкой концентрацией, меньшим временем ношения или десенсибилизирующим гелем перед сеансом."
        },
        {
          "q": "Сколько держится результат?",
          "a": "От шести месяцев до двух лет у большинства людей. Кофе, чай, красное вино, куркума и курение ускоряют возврат цвета; гигиенический визит раз в полгода и поддерживающая каппа время от времени помогают удерживать оттенок."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографию при дневном свете",
      "text": "Снимка, сделанного у окна и без фильтра, обычно достаточно, чтобы сказать, какой у вас тип пигментации, сработает ли отбеливание и нужно ли планировать его с учётом реставраций.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра зубов и дёсен и изучения анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Отбеливание зубов в Стамбуле | Platinya",
    "seoDesc": "Отбеливание зубов в Стамбуле: сеанс 45–90 минут, обычно 1–2 сеанса, результат держится 6–24 месяца. Что отбеливание не меняет."
  },
  "/dental-implants": {
    "title": "Зубные импланты в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Имплант — это титановый винт, установленный в челюстную кость; за три-шесть месяцев кость обрастает его, после чего сверху фиксируют коронку, мост или полную дугу. Он заменяет корень, поэтому не зависит от соседних зубов.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по зубным имплантам в Platinya Clinic",
    "stats": [
      {
        "value": "3–6 месяцев",
        "label": "Приживление до коронки"
      },
      {
        "value": "45–90 мин",
        "label": "Установка одного импланта"
      },
      {
        "value": "10–15 лет и более",
        "label": "Функция при уходе"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Решают объём кости, её качество, состояние дёсен и то, насколько хорошо контролируются общие заболевания.",
      "items": [
        "Один отсутствующий зуб при здоровых соседних, которые не нужно препарировать под мост",
        "Несколько отсутствующих зубов в одном ряду или полная дуга, которая подвижна или больше не держится",
        "Достаточный объём кости — или кость, которую можно восстановить графтом либо синус-лифтингом",
        "Контролируемый диабет, отсутствие курения или готовность бросить, а также отсутствие недавней лучевой терапии и лечения антирезорбтивными препаратами на челюсти"
      ],
      "note": "Курение — единственное, что важнее всего изменить: оно примерно вдвое повышает риск того, что имплант не приживётся, и эффект зависит от количества выкуриваемого. Неконтролируемый диабет влияет на заживление сходным образом."
    },
    "techniques": {
      "heading": "Один зуб, несколько зубов или полная дуга",
      "intro": "Число и положение имплантов определяют по имеющейся кости и по тому, как прикус распределяет нагрузку, а не по числу отсутствующих зубов.",
      "items": [
        {
          "name": "Один имплант и коронка",
          "text": "Самый щадящий вариант при утрате одного зуба: соседние зубы не препарируются. Установка занимает 45–90 минут под местной анестезией, затем три-шесть месяцев приживления до изготовления коронки."
        },
        {
          "name": "Мост на имплантах",
          "text": "При нескольких отсутствующих зубах подряд мост несут два или более импланта, поэтому крайние зубы остаются нетронутыми. Имплантов меньше, чем замещаемых зубов, поэтому протяжённость моста нужно планировать тщательно, а не удлинять ради экономии одной опоры."
        },
        {
          "name": "All-on-4 и All-on-6",
          "text": "Полная дуга фиксируется на четырёх или шести имплантах, причём задние устанавливают под наклоном, чтобы использовать оставшуюся кость и часто избежать графтинга. Временный мост обычно можно поставить в течение нескольких дней; постоянный ждёт заживления. Подходит не всем: решают объём кости, прикус и поддержка губы."
        }
      ]
    },
    "journey": {
      "heading": "От сканирования до окончательной коронки",
      "steps": [
        {
          "name": "Обследование и планирование",
          "text": "КЛКТ измеряет высоту и ширину кости и показывает, где проходят нерв и пазуха. Если кость тонкая, сначала планируют графт или синус-лифтинг, что добавляет четыре-шесть месяцев до установки импланта."
        },
        {
          "name": "Установка",
          "text": "Под местной анестезией, 45–90 минут на один имплант. Фиксируют показатели стабильности, а временный зуб или протез корректируют так, чтобы он не нагружал имплант во время приживления."
        },
        {
          "name": "Остеоинтеграция",
          "text": "Три-шесть месяцев, в течение которых имплант не трогают. Нижняя челюсть обычно готова раньше верхней, а зоны с графтом требуют больше времени. Курение и плохо контролируемый диабет замедляют этот этап."
        },
        {
          "name": "Формирователь и слепок",
          "text": "Десну формируют вокруг формирователя, затем снимают скан или слепок и изготавливают коронку либо мост — обычно одна-три недели работы лаборатории."
        },
        {
          "name": "Фиксация и обслуживание",
          "text": "Конструкцию фиксируют на винт или цемент и проверяют прикус. Гигиенические визиты каждые шесть месяцев, снимок через год и затем периодически: потеря кости вокруг импланта долго протекает бессимптомно."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Операция по установке импланта рутинна, но это по-прежнему вмешательство в кость, и варианты неудач здесь специфичны. Вот важнейшие из них.",
      "items": [
        "Отсутствие приживления: имплант становится подвижным и его приходится удалять — более вероятно у курящих, при тонкой кости и неконтролируемом диабете",
        "Пери-имплантит, потеря кости вокруг функционирующего импланта, обычно связанная с налётом; сам он не обращается вспять",
        "Повреждение нерва в нижней челюсти с онемением губы, подбородка или языка — обычно временное, иногда постоянное",
        "Перфорация пазухи или неудача графта в верхней челюсти, что может потребовать повторной процедуры",
        "Перелом компонента, ослабление винта или скол коронки — устранимо, но не бесплатно"
      ],
      "note": "Имплант — не зуб. У него нет связки, обратная связь при чрезмерной нагрузке снижена, а потерянную вокруг него кость восстановить невозможно. Гигиена и ночная каппа важнее бренда на упаковке."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Операция болезненна?",
          "a": "Под местной анестезией вы чувствуете давление и вибрацию, а не боль. Первые два дня — отёк и болезненность, обычно достаточно обычного парацетамола или ибупрофена; большинство возвращается к офисной работе на следующий день."
        },
        {
          "q": "Сколько времени занимает всё вместе?",
          "a": "От четырёх до восьми месяцев от установки до окончательной коронки при одном импланте, потому что сроки задаёт кость. Полная дуга на All-on-4 может получить несъёмный временный мост за несколько дней, а постоянный — через четыре-шесть месяцев."
        },
        {
          "q": "Можно ли курить?",
          "a": "В идеале — нет вовсе на время лечения. Отказ минимум за неделю до установки и примерно на восемь недель после заметно повышает шансы на приживление; курение после увеличивает долгосрочный риск потери кости вокруг импланта."
        },
        {
          "q": "А если кости недостаточно?",
          "a": "Кость можно добавить: гранулированный графт с мембраной для ширины, блочный графт при больших дефектах или синус-лифтинг для заднего отдела верхней челюсти. Это отдельная процедура со своим сроком заживления, и её планируют по скану, а не обнаруживают во время операции."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте вашу панорамную рентгенограмму",
      "text": "Свежей панорамной рентгенограммы или КЛКТ и перечня отсутствующих зубов достаточно, чтобы сказать, вероятен ли графтинг, сколько примерно нужно имплантов и сколько продлится план.",
      "button": "Отправить снимок"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра полости рта, изучения КЛКТ и анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Зубные импланты в Стамбуле | Platinya",
    "seoDesc": "Зубные импланты в Стамбуле: приживление 3–6 месяцев, установка одного импланта 45–90 минут, срок службы от 10–15 лет. Показания и риски."
  },
  "/zircon-teeth": {
    "title": "Циркониевые коронки в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Циркониевую коронку фрезеруют из блока диоксида циркония и спекают до твёрдости. Её применяют там, где металлокерамика дала бы серую линию у десны, и она достаточно прочна и для жевательных, и для передних зубов.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по циркониевым коронкам в Platinya Clinic",
    "stats": [
      {
        "value": "2 визита",
        "label": "В клинике"
      },
      {
        "value": "5–7 дней",
        "label": "Работа лаборатории"
      },
      {
        "value": "10–15 лет",
        "label": "Обычный срок службы"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Цирконий выбирают ради прочности, ради эстетики без металла или ради того и другого. Он не лучше качественной металлокерамики автоматически — он другой.",
      "items": [
        "Сильно пломбированные, депульпированные или треснувшие зубы, которым нужно полное покрытие",
        "Жевательные зубы под большой нагрузкой, где тонкая цельнокерамическая коронка скалывалась бы",
        "Видимые передние зубы, где у десны не должно быть металла",
        "Известная чувствительность к металлу или существующая металлокерамическая коронка с тёмным краем"
      ],
      "note": "Коронке нужен достаточный объём зуба, чтобы держаться. Если над десной остаётся очень мало, сначала может понадобиться восстановление культи или удлинение коронковой части: коронка не может бесконечно замещать утраченные ткани зуба."
    },
    "techniques": {
      "heading": "Монолитная или слоистая",
      "intro": "И то и другое — цирконий. Разница в том, вся ли коронка из одного материала или это прочная основа с фарфором сверху, и это определяет и вид, и характер неудач.",
      "items": [
        {
          "name": "Монолитный цирконий",
          "text": "Вся коронка фрезеруется из циркония, спекается и полируется. Самый прочный вариант для моляров и для тех, кто скрипит зубами; менее прозрачен, чем слоистая керамика, поэтому на переднем зубе может выглядеть плоским, если не тщательно проработать оттенок и текстуру поверхности."
        },
        {
          "name": "Слоистый цирконий",
          "text": "Основа из циркония с нанесённым поверх фарфором. Лучше в переднем отделе, где свет должен проходить через зуб, но облицовочный фарфор может скалываться — обычная слабость этой конструкции. Разумный компромисс для премоляров и видимых зубов."
        },
        {
          "name": "Металлокерамика для сравнения",
          "text": "Металлический каркас с наплавленным фарфором: предсказуемо, дешевле и очень хорошо изучено. Слабое место — эстетика: непрозрачный каркас и со временем серая линия там, где десна отходит от металла."
        }
      ]
    },
    "journey": {
      "heading": "От препарирования до фиксации коронки",
      "steps": [
        {
          "name": "Обследование",
          "text": "Сначала выясняют, почему зубу нужна коронка: трещина, крупная старая пломба, лечение каналов. Объём сохранившейся над десной ткани определяет, достаточно ли одной коронки."
        },
        {
          "name": "Препарирование",
          "text": "Под местной анестезией зуб сошлифовывают на 1–1,5 мм, больше там, где будет слой фарфора. Снимают скан или слепок и устанавливают временную коронку, чтобы зуб был защищён и не смещался."
        },
        {
          "name": "Дизайн и фрезерование",
          "text": "Коронку проектируют в CAD, фрезеруют из циркониевой заготовки и спекают при высокой температуре, затем окрашивают и глазуруют. Именно здесь задаётся оттенок: цвет, подобранный под лампу в кабинете, будет выглядеть неверно при дневном свете."
        },
        {
          "name": "Примерка и фиксация",
          "text": "До фиксации проверяют посадку, контактные пункты и оттенок. Затем коронку сажают на композитный или стеклоиономерный цемент и уточняют прикус, пока контакты не станут равномерными."
        },
        {
          "name": "Контроль",
          "text": "Осмотр через одну-две недели, главным образом по прикусу. При признаках скрипа изготавливают ночную каппу: коронка защищает зуб, но не себя от тяжёлого прикуса."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Цирконий прочен, но коронка — это реставрация на зубе, который уже однажды не справился. Вот реалистичные проблемы.",
      "items": [
        "Коронка может слететь, если культя низкая или цемент несостоятелен, — обычно её можно фиксировать повторно",
        "Скол облицовочного фарфора, чаще на тонкой коронке или под тяжёлым прикусом",
        "Цирконий твёрже эмали и со временем может стирать зуб-антагонист, особенно если поверхность оставлена неотполированной",
        "Монолитная коронка в переднем отделе может выглядеть непрозрачной или слишком однородной, особенно при ярком свете",
        "Воспаление пульпы или необходимость лечения каналов после препарирования зуба, который уже был скомпрометирован"
      ],
      "note": "Коронка хороша настолько, насколько хороша опора под ней. Если зуб треснул ниже десны или от него осталось очень мало, честным вариантом может быть удаление и имплант, а не третья коронка на тот же зуб."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это лучше металлокерамики?",
          "a": "У десны — да: металлического воротника нет, поэтому серая линия при рецессии не появляется. По цвету и прозрачности хорошо слоистая керамика всё ещё может выглядеть лучше. Монолитный цирконий выигрывает в прочности, а не в достоверности."
        },
        {
          "q": "Цирконий ломается?",
          "a": "Монолитная коронка как единое целое ломается редко — это самая прочная керамическая коронка в обычной практике. Частая неудача — скол фарфорового слоя на слоистой коронке, что устранимо, но не незаметно."
        },
        {
          "q": "Можно ли ставить на жевательные зубы?",
          "a": "Да, в этом её главное преимущество. Моляры несут самую большую нагрузку, и цирконий справляется с ней лучше стеклокерамики. Для второго моляра монолитная коронка обычно разумный выбор."
        },
        {
          "q": "Сколько она прослужит?",
          "a": "Десять-пятнадцать лет — обоснованное ожидание, иногда дольше. Ограничивает редко сам цирконий: важнее зуб под ним, край десны и то, контролируется ли прикус."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографию зуба",
      "text": "Крупной фотографии и снимка зуба достаточно, чтобы сказать, что разумнее — циркониевая коронка, вкладка или удаление, и почему.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после осмотра зуба, дёсен и прикуса и изучения анамнеза; результаты у разных пациентов различаются.",
    "seoTitle": "Циркониевые коронки в Стамбуле | Platinya",
    "seoDesc": "Циркониевые коронки в Стамбуле: два визита, 5–7 дней работы лаборатории, срок службы 10–15 лет. Монолитные и слоистые, показания и риски."
  },
  "/periodontics": {
    "title": "Лечение дёсен (пародонтология) в Стамбуле",
    "eyebrow": "Стоматология",
    "lead": "Заболевание дёсен начинается с воспаления, при котором кровоточит чистка, а заканчивается подвижностью и потерей зубов. Лечение убирает бактериальные отложения с поверхности корня, а затем не даёт им вернуться. Болезнь контролируют, но не излечивают.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Пародонтологическое обследование в Platinya Clinic",
    "stats": [
      {
        "value": "1–4 визита",
        "label": "Снятие камня и кюретаж"
      },
      {
        "value": "6–8 недель",
        "label": "До повторной оценки"
      },
      {
        "value": "3–6 месяцев",
        "label": "Интервал поддержки"
      }
    ],
    "candidate": {
      "heading": "Кому нужно лечение",
      "intro": "Начальное лечение показано почти всем, у кого кровоточат дёсны. План меняют глубина карманов и то, сколько кости уже потеряно.",
      "items": [
        "Кровоточивость при чистке зубов или использовании флосса, даже без боли",
        "Стойкий запах изо рта или металлический привкус при видимом камне у десны",
        "Дёсны, которые опустились, или зубы, которые кажутся длиннее, чем раньше",
        "Карманы глубже 4 мм при зондировании или зубы, которые начали смещаться"
      ],
      "note": "Курение скрывает признаки: оно сужает сосуды, поэтому дёсны кровоточат меньше, а болезнь продолжается. Диабет и беременность тоже меняют реакцию тканей, поэтому о них и спрашивают."
    },
    "techniques": {
      "heading": "Чистка, операция или графтинг",
      "intro": "Почти любой случай начинается с одного и того же шага — удаления того, что на корне. Остальное определяет, как поведёт себя ткань после этого.",
      "items": [
        {
          "name": "Снятие камня и кюретаж",
          "text": "Глубокая чистка под местной анестезией, обычно по одному квадранту за раз, с удалением камня и бактериальных отложений из-под десны. Это лечение для большинства случаев; операцию рассматривают только если карманы остаются глубокими."
        },
        {
          "name": "Кюретаж и лоскутная операция",
          "text": "Если после начальной терапии карманы остаются глубокими, десну откидывают, поверхности корней очищают под прямым контролем зрения и ткань укладывают обратно. Это оставляют для участков, не ответивших на лечение, а не первый шаг."
        },
        {
          "name": "Графтинг десны при рецессии",
          "text": "Когда корень обнажён, чувствителен или рецессия прогрессирует, ткань берут с нёба и пересаживают на корень. Это закрывает корень и утолщает десну, но не возвращает уже утраченную кость."
        }
      ]
    },
    "journey": {
      "heading": "От карты обследования до поддержки",
      "steps": [
        {
          "name": "Пародонтологическая карта",
          "text": "Глубина зондирования вокруг каждого зуба, индексы кровоточивости, подвижность и снимки для оценки уровня кости. Именно эта запись делает изменения измеримыми позже; без неё лечение оценивают по впечатлению."
        },
        {
          "name": "Начальная терапия",
          "text": "Снятие камня и кюретаж за один-четыре приёма с интервалом в неделю-две, с местной анестезией там, где карманы глубокие. Одновременно корректируют технику чистки, потому что чистка даёт лишь новое начало."
        },
        {
          "name": "Повторная оценка через шесть-восемь недель",
          "text": "Карманы измеряют снова. Неглубокие часто улучшаются на миллиметр-два; глубокие нередко нет, и именно такие участки требуют решения."
        },
        {
          "name": "Операция, если она нужна",
          "text": "Планируется только для участков, не ответивших на лечение, и только после повторной оценки. Это меньшая процедура, чем звучит, но всё же операция со своим сроком заживления."
        },
        {
          "name": "Поддержка",
          "text": "Визиты каждые три-шесть месяцев с повторным зондированием. Именно эта часть определяет, сохранятся ли зубы: болезнь возвращается везде, где биоплёнке дают спокойно восстановиться."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Большая часть того, что пациенты считают осложнением, — это заживление тканей. Настоящие риски другие, и о них стоит сказать прямо.",
      "items": [
        "Дёсны уменьшаются, когда воспаление стихает, поэтому зубы кажутся длиннее, а корни могут обнажиться — это заживление, а не повреждение",
        "Чувствительность к холодному на обнажённых корнях, иногда неделями",
        "Кровоточивость и болезненность несколько дней после глубокой чистки, а также чувствительность при еде",
        "Болезнь хроническая: без поддержки она возвращается, а уже потерянная кость не восстанавливается",
        "В запущенных случаях зубы всё равно могут быть потеряны; цель — сохранить остальные, а не обещать каждый"
      ],
      "note": "Курение — самый важный фактор, который вы можете изменить: оно притупляет ответ на лечение и скрывает кровоточивость, которая привела бы вас раньше. Отказ меняет прогноз сильнее любого ополаскивателя."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Не расшатает ли глубокая чистка зубы?",
          "a": "Нет. Зубы могут ощущаться подвижными несколько дней, потому что ушёл камень, который их поддерживал, и спал отёк; по мере заживления тканей они укрепляются. Там, где потеря кости выражена, зуб был подвижным ещё до лечения."
        },
        {
          "q": "Это излечение?",
          "a": "Нет, это контроль. Пародонтит не исчезает, но его можно удерживать в стабильном состоянии. Именно поддержка каждые три-шесть месяцев удерживает его, и её пропуск — самая частая причина потери зубов в дальнейшем."
        },
        {
          "q": "Это больно?",
          "a": "Чистку делают под местной анестезией, поэтому во время — нет. После дёсны болезненны два-три дня, а корни могут быть чувствительны к холодному несколько недель; и то и другое проходит при обычном обезболивании и десенсибилизирующей пасте."
        },
        {
          "q": "Как часто нужно приходить?",
          "a": "Каждые три месяца, если карманы были глубокими, вы курите или диабет плохо контролируется; каждые шесть месяцев при более лёгких случаях. Интервал определяют на повторной оценке по измерениям, а не по общему правилу."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографию ваших дёсен",
      "text": "Фотографии края десны и свежего снимка достаточно для первого мнения: это гингивит, пародонтит или то, что нужно увидеть в кресле.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Заболевание дёсен диагностируют только зондированием и снимками; показания к лечению оценивают после осмотра, и результаты у разных пациентов различаются.",
    "seoTitle": "Лечение дёсен в Стамбуле | Platinya",
    "seoDesc": "Лечение дёсен в Стамбуле: снятие камня и кюретаж за 1–4 визита, повторная оценка через 6–8 недель, поддержка каждые 3–6 месяцев."
  },
  "/facelift-surgery": {
    "title": "Подтяжка лица в Стамбуле (глубокий SMAS-лифтинг)",
    "eyebrow": "Пластика лица",
    "lead": "Подтяжка лица поднимает мягкие ткани лица и шеи, которые опустились с возрастом, и удаляет кожу, которая им больше не соответствует. Она меняет линию челюсти и шею, а не поверхность кожи.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по подтяжке лица в Platinya Clinic",
    "stats": [
      {
        "value": "2–4 ч",
        "label": "Длительность операции"
      },
      {
        "value": "1–2 ночи",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "2–3 недели",
        "label": "Срок до выхода в люди"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Операция работает с дряблостью, а не с морщинами. Она подходит тем, у кого вес стабилен, кожа сохранила упругость и кто хочет выглядеть собой, но отдохнувшим.",
      "items": [
        "Брыли вдоль линии челюсти и складка, идущая от носа к углу рта",
        "Опустившаяся средняя зона лица с уплощением над скулами",
        "Дряблая кожа и вертикальные тяжи на шее",
        "Общее состояние здоровья, достаточное для общего наркоза, и отказ от курения на месяц"
      ],
      "note": "Подтяжка лица не останавливает старение: после операции лицо продолжает меняться с той же скоростью. Мелкие морщины, пигментацию и фотостарение лечат другими методами — лазером, пилингами или ботулотоксином — и часто сочетают с операцией, а не заменяют ею."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "План строят по тканям, костям и шее — при осмотре, в покое и в движении. По фотографии дряблость не оценить.",
      "items": [
        {
          "name": "Глубокий SMAS-лифтинг",
          "text": "Глубокие слои лица мобилизуют и поднимают как единый блок, поэтому натяжение несёт прочная ткань, а не кожа. Это даёт наиболее естественную линию челюсти и самый долгий результат и применяется, когда средняя зона лица опустилась."
        },
        {
          "name": "SMAS-лифтинг с более коротким рубцом",
          "text": "Мышечный слой подтягивают через более короткий разрез, без глубокой мобилизации. Меньше времени операции и меньше отёка, хороший вариант при ранней дряблости, но он работает больше с нижней частью лица, чем со средней."
        },
        {
          "name": "Платизмопластика (подтяжка шеи)",
          "text": "Мышцы шеи сближают по средней линии и удаляют дряблую кожу через небольшой разрез под подбородком и разрез за ухом. Часто именно эту часть операции пациенты замечают больше всего."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Лицо осматривают сидя и лёжа, оценивают шею и линию роста волос, делают фотографии. Анализы крови и, при необходимости, заключение кардиолога назначают до согласования даты. Положение рубца обсуждают заранее."
        },
        {
          "name": "Подготовка",
          "text": "Курение прекращают минимум за четыре недели до операции — это важнейший фактор заживления ран на лице. Антикоагулянты и некоторые добавки отменяют примерно за десять дней, есть и пить нельзя шесть-восемь часов. Договоритесь о помощи дома в первую неделю."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом, обычно от двух до четырёх часов. Разрез идёт перед ухом и за ухом, а в области виска уходит в линию роста волос, поэтому скрыт ухом и волосами. С каждой стороны часто оставляют дренаж на день-два, большинство пациентов остаются на одну-две ночи."
        },
        {
          "name": "Первые две недели",
          "text": "Отёк и гематомы максимальны примерно на второй-четвёртый день, затем спадают. Голову держат приподнятой, в первые дни применяют холодные компрессы, дренаж удаляют в клинике. Большинство пациентов считают, что могут выйти из дома — в солнечных очках — через семь-десять дней."
        },
        {
          "name": "С третьей по шестую неделю, и рубец",
          "text": "Макияж и окрашивание волос возобновляют примерно через две недели, тренировки — через четыре-шесть. Рубец плотный и розовый два-три месяца, затем бледнеет в течение двенадцати-восемнадцати месяцев; он проходит за ухом и, где возможно, внутри линии роста волос."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Это настоящая операция рядом с лицевым нервом, и риски стоит услышать до решения, а не после.",
      "items": [
        "Гематома — скопление крови под кожей; самое частое осложнение, иногда её нужно опорожнить",
        "Временная слабость лицевого нерва, которая обычно восстанавливается за недели или месяцы; стойкое повреждение редко",
        "Проблемы заживления или некроз кожи, что гораздо вероятнее у курящих и при нарушении кровообращения",
        "Широкий или плотный рубец, небольшие участки выпадения волос вдоль разреза и онемение перед ухом, обычно улучшающееся за месяцы",
        "Асимметрия или результат, который оценивают как слишком натянутый либо слишком слабый, с необходимостью коррекции"
      ],
      "note": "Сообщите о курении, диабете, давлении, антикоагулянтах и любых перенесённых операциях или введениях филлера в области лица. Филлеры и нити меняют анатомию и план, а их сокрытие — самый быстрый путь к осложнённой операции."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Я буду выглядеть как другой человек?",
          "a": "Цель в том, чтобы вы выглядели собой, но отдохнувшим. Подтяжка поднимает опустившиеся ткани; она не меняет форму носа, глаз или характер лица. Очевидно оперированный вид обычно возникает, когда кожу натягивают слишком сильно, поэтому здесь натяжение несут глубокие слои."
        },
        {
          "q": "Сколько держится результат?",
          "a": "Большинство пациентов видят изменение семь-десять лет, а на шее часто дольше. Результат не постоянен, потому что лицо продолжает стареть в своём темпе. Сохранение стабильного веса и защита кожи от солнца помогают."
        },
        {
          "q": "Когда можно появляться на людях?",
          "a": "Большинство чувствуют себя комфортно через десять-четырнадцать дней, с остаточным отёком, который легко скрыть. Лицо продолжает формироваться три-шесть месяцев, и окончательную линию челюсти оценивают примерно тогда."
        },
        {
          "q": "Можно ли сочетать с операцией на веках?",
          "a": "Часто да — блефаропластику верхних или нижних век, подтяжку бровей или липофилинг скул нередко выполняют в том же сеансе. Безопасно ли это, зависит от общей длительности операции и вашего здоровья, и решается на консультации."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Трёх снимков — анфас, в полупрофиль и в профиль — достаточно, чтобы хирург сказал, подходящая ли это операция и какая техника подойдёт. Координатор вернётся с планом, датой и письменным расчётом стоимости.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Подтяжка лица в Стамбуле | Platinya",
    "seoDesc": "Подтяжка лица в Стамбуле: операция 2–4 часа, 1–2 ночи в стационаре, выход в люди через 2–3 недели. Техники, рубец и риски."
  },
  "/blepharoplasty": {
    "title": "Блефаропластика (операция на веках) в Стамбуле",
    "eyebrow": "Пластика лица",
    "lead": "Блефаропластика удаляет излишки кожи верхних век и жир, из-за которого нижние веки выглядят уставшими и отёчными. Это одна из самых малых операций на лице — и одна из тех, где легче всего ошибиться.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по операции на веках в Platinya Clinic",
    "stats": [
      {
        "value": "1–2 ч",
        "label": "Длительность операции"
      },
      {
        "value": "5–7 дней",
        "label": "Снятие швов"
      },
      {
        "value": "7–10 дней",
        "label": "Выход в люди"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Операция работает с кожей и жиром, а не с цветом и качеством кожи. Тёмные круги от пигмента или западение под глазом — другая задача с другим решением.",
      "items": [
        "Нависающие верхние веки или кожа, которая лежит на ресницах и сужает поле зрения",
        "Кожа верхнего века, которая образует складки, тяжёлая или асимметричная",
        "Отёчные нижние веки из-за сместившегося вперёд жира, а не из-за жидкости",
        "Дряблая кожа нижних век с видимым жировым мешком или без него"
      ],
      "note": "Синдром сухого глаза, тиреоидная офтальмопатия, глаукома и повышенное давление меняют план, а некоторые из них — причина подождать. Заболевание щитовидной железы должно быть в стабильной фазе: операция при активной офтальмопатии может её ухудшить."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Верхние и нижние веки — отдельные решения. Многим пациентам нужна только одна зона, и именно избыток вмешательства приводит к запавшему виду век.",
      "items": [
        {
          "name": "Блефаропластика верхних век",
          "text": "Тонкий разрез в естественной складке, излишки кожи удаляют вместе с полоской мышцы; жир иссекают только там, где он выбухает. Рубец лежит в складке и бледнеет за три-шесть месяцев. Именно эта часть расширяет поле зрения."
        },
        {
          "name": "Нижние веки, трансконъюнктивальный доступ",
          "text": "Жир удаляют через внутреннюю поверхность века, поэтому разреза на коже и наружного рубца нет. Подходит при жировых мешках и хорошем тонусе кожи; дряблую кожу он не убирает. Часто сочетается с перемещением жира для заполнения слёзной борозды."
        },
        {
          "name": "Нижние веки, наружный доступ с кантопексией",
          "text": "Разрез сразу под ресницами удаляет и кожу, и жир, а угол века поддерживают, чтобы он не опускался. Применяется при реальном избытке кожи — и это та техника, где риск выворота века нужно тщательно контролировать."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Веки осматривают с открытыми и закрытыми глазами, измеряют объём кожи, который нужно сохранить, оценивают сухость глаза. Делают фотографии. При любых сомнениях по слёзной плёнке или щитовидной железе до назначения даты назначают консультацию офтальмолога."
        },
        {
          "name": "Подготовка",
          "text": "Антикоагулянты, аспирин и некоторые добавки отменяют примерно за десять дней, курение прекращают за четыре недели. Есть и пить нельзя шесть-восемь часов. Договоритесь, кто отвезёт вас домой: глаза отёчны, и вести машину нельзя."
        },
        {
          "name": "Операция",
          "text": "Местная анестезия с лёгкой седацией или общий наркоз, от одного до двух часов на оба века. При местной анестезии вы в сознании и можете говорить с хирургом. Швы тонкие, их снимают через пять-семь дней; часть может быть рассасывающейся."
        },
        {
          "name": "Первая неделя",
          "text": "Гематомы и отёк ожидаемы и могут быть значительными в первые три-четыре дня. Холодные компрессы, приподнятое положение головы, капли. Нечёткость зрения скорее от мази, чем от операции. Контактные линзы нельзя около двух недель."
        },
        {
          "name": "Со второй по двенадцатую неделю",
          "text": "Большинство выглядит приемлемо через семь-десять дней, макияж — примерно с десятого дня. Остаточный отёк спадает за четыре-шесть недель, рубец размягчается за три-шесть месяцев. В этот период важна защита век от солнца."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "У операции на веках короткий список рисков, и один из них — неотложный. Все их стоит прочитать до операции.",
      "items": [
        "Эктропион или ретракция нижнего века: веко оттягивается вниз, глаз полностью не закрывается, становится сухим и с ощущением песка; может потребоваться коррекция",
        "Асимметрия сторон или удаление слишком большого объёма кожи, что трудно исправить",
        "Гематома за глазом — редко, но с угрозой для зрения, и это причина немедленно вернуться",
        "Двоение зрения из-за повреждения мышц, двигающих глаз; обычно временное, редко стойкое",
        "Заметные или плотные рубцы и небольшие кисты вдоль линии разреза"
      ],
      "note": "Сообщите о сухости глаз, использовании контактных линз, заболеваниях щитовидной железы, глаукоме, нарушениях свёртываемости и любых антикоагулянтах, включая аспирин и рыбий жир. Скажите также, если вам вводили филлер или делали лазер вокруг глаз: это меняет поведение тканей."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Изменится ли форма моих глаз?",
          "a": "Форму задают веки и бровь, и операцию планируют с их учётом. Удаление кожи открывает глаз, но не должно делать его круглее или испуганным. Если бровь низкая, часто правильнее поднять бровь, а не снимать больше кожи."
        },
        {
          "q": "Можно ли убрать тёмные круги?",
          "a": "Частично, и только если темнота — это тень от жирового мешка или от западения. Темнота от пигмента в коже операцией не меняется и лечится кремами, пилингами или лазером. Это самое частое недоразумение об этой операции."
        },
        {
          "q": "Сколько держится результат?",
          "a": "Обычно пять-десять лет, на верхних веках иногда дольше. Кожа продолжает стареть, а бровь опускаться, поэтому результат — улучшение, а не постоянное состояние. Небольшую повторную процедуру иногда делают спустя годы."
        },
        {
          "q": "Верхние или нижние — что нужно мне?",
          "a": "Это решается осмотром. Нависание и суженное поле зрения указывают на верхние веки; отёчность и тень под глазом — на нижние. Многим предлагают только одну зону, а сочетание — это решение не только о результате, но и о сроках заживления."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Снимка анфас с открытыми глазами и снимка с мягко закрытыми достаточно, чтобы хирург оценил, какое веко требует работы и сколько кожи можно безопасно сохранить. Координатор ответит с планом и письменным расчётом.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Блефаропластика в Стамбуле | Platinya",
    "seoDesc": "Блефаропластика в Стамбуле: операция 1–2 часа, швы снимают через 5–7 дней, выход в люди через 7–10 дней. Техники и риски."
  },
  "/chin-implants": {
    "title": "Увеличение подбородка в Стамбуле (имплант и гениопластика)",
    "eyebrow": "Пластика лица",
    "lead": "Слабый или скошенный подбородок меняет баланс всего лица: нос кажется крупнее, линия челюсти мягче, шея короче. Увеличение подбородка выдвигает его вперёд — имплантом, перемещением кости или временно филлером.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по увеличению подбородка в Platinya Clinic",
    "stats": [
      {
        "value": "1–2 ч",
        "label": "Длительность операции"
      },
      {
        "value": "1 ночь",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "1–2 недели",
        "label": "Заметный отёк"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Оценка касается пропорций и прикуса, а не только подбородка. Подбородок оценивают в соотношении с носом, губами и углом челюсти.",
      "items": [
        "Подбородок, который в профиль находится позади линии нижней губы",
        "Линия челюсти, которая выглядит мягкой или короткой анфас",
        "Асимметрия после травмы или перенесённой операции на челюсти",
        "Подбородок, который рассматривают вместе с ринопластикой, чтобы сохранить баланс профиля"
      ],
      "note": "Если зубы смыкаются неправильно, основная проблема — прикус, и имплант её не исправит. Нужна ортодонтическая и челюстно-лицевая оценка, а иногда ортогнатическая операция — перемещение самой челюсти, — а не имплант перед ней."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Под одним названием продают три разные операции. Они различаются тем, что перемещают, насколько обратимы и как долго держатся.",
      "items": [
        {
          "name": "Силиконовый имплант подбородка",
          "text": "Мягкий цельный имплант устанавливают на кость через небольшой разрез внутри нижней губы или иногда под подбородком. Он добавляет выступ и ширину, операция занимает около часа, и позже его можно удалить или заменить. Имплант лежит на кости и не срастается с ней."
        },
        {
          "name": "Скользящая гениопластика",
          "text": "Кость подбородка рассекают, выдвигают вперёд — или вниз, или в сторону — и фиксируют небольшими пластинами и винтами. Используется собственная кость, поэтому нет импланта, который может сместиться, и можно исправить вертикальную длину и асимметрию, недоступные импланту. Операция больше, отёк выраженнее."
        },
        {
          "name": "Филлер на гиалуроновой кислоте",
          "text": "Временный вариант, выполняется в клинике менее чем за час, без периода восстановления. Он показывает, как будет выглядеть выступ, до решения об операции, и держится примерно девять-восемнадцать месяцев. Исправить короткую или асимметричную кость он не может."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Фотографии в профиль, измерения лица и осмотр прикуса. Если планируется перемещение кости или есть вопросы по прикусу, назначают телерентгенограмму или КТ. Размер и форму импланта подбирают по модели вашего лица."
        },
        {
          "name": "Подготовка",
          "text": "Анализы крови и осмотр стоматолога, если разрез будет во рту: зубы и дёсны должны быть здоровы перед внутриротовой операцией. Курение прекращают за четыре недели. Антикоагулянты отменяют примерно за десять дней, есть и пить нельзя шесть-восемь часов."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом или глубокой седацией, от одного до двух часов. Имплант вводят через разрез внутри нижней губы, поэтому на коже рубца нет; разрез ушивают рассасывающимися нитями. Большинство пациентов остаются на одну ночь."
        },
        {
          "name": "Первая неделя",
          "text": "Отёк максимален через сорок восемь — семьдесят два часа, нижняя губа и подбородок ощущаются скованными и онемевшими. Мягкая пища, не жевать передними зубами, полоскание после каждого приёма пищи, сон с приподнятой головой. Гематомы могут спускаться на шею и проходят за неделю."
        },
        {
          "name": "Со второй по шестую неделю",
          "text": "Большая часть отёка уходит за две-три недели, остальное — за три месяца. Онемение нижней губы улучшается постепенно, иногда в течение нескольких месяцев. Контактный спорт и лечение зубов — примерно через шесть недель."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Подбородок близко к подбородочному нерву, а разрез соседствует со ртом — оба обстоятельства формируют список рисков.",
      "items": [
        "Инфекция, более вероятная при разрезе во рту; инфицированный имплант обычно приходится удалять",
        "Изменение чувствительности нижней губы и подбородка из-за растяжения или травмы подбородочного нерва — обычно временное, иногда нет",
        "Смещение импланта или заметный край вдоль кости, либо асимметрия и выступ, оценённый как чрезмерный или недостаточный, с необходимостью коррекции",
        "Резорбция кости под длительно стоящим имплантом, из-за чего он со временем может сидеть хуже",
        "При гениопластике: кровотечение, повреждение корней зубов и проблемы с фиксирующими пластинами"
      ],
      "note": "Сообщите о перенесённых операциях на подбородке или челюсти, ортодонтическом лечении, заболеваниях дёсен и любых аутоиммунных состояниях. Скажите также, если скрипите зубами или есть боль в ВНЧС: после перемещения подбородка сустав нагружается иначе."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Будет ли заметно, что я это сделал?",
          "a": "Цель — пропорция, а не размер. Имплант, подобранный под ваше лицо, читается как более чёткая линия челюсти, а не как подбородок. Разрез внутри губы, поэтому на лице рубца нет; цена этого — короткий период отёка и онемение нижней губы."
        },
        {
          "q": "Имплант или гениопластика — что лучше?",
          "a": "Имплант быстрее, обратим и хорош для добавления выступа вперёд. Гениопластика перемещает собственную кость, поэтому может удлинить подбородок, исправить асимметрию и избежать инородного тела — ценой более крупной операции. Правильный ответ зависит от того, что именно коротко, и это измеряют, а не угадывают."
        },
        {
          "q": "Сколько служит имплант?",
          "a": "Силиконовый имплант не рассчитан на обязательную замену, и многие стоят десятилетиями. Он не постоянен в том смысле, что не требует внимания: его можно удалить или заменить, и его нужно осмотреть, если появилась боль, смещение или изменилась форма подбородка."
        },
        {
          "q": "Можно ли сделать вместе с операцией на нос?",
          "a": "Да, и часто это лучший план: профиль — это соотношение носа и подбородка, и изменение только одного может сделать второе неверным. Сочетанная операция длиннее, поэтому её планируют как одну процедуру с одним восстановлением."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Снимка в профиль и анфас достаточно, чтобы сказать, в подбородке ли дело и что разумнее — имплант, кость или филлер. Координатор вернётся с планом и письменным расчётом стоимости.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Увеличение подбородка в Стамбуле | Platinya",
    "seoDesc": "Увеличение подбородка в Стамбуле: операция 1–2 часа, одна ночь в стационаре, заметный отёк 1–2 недели. Имплант, гениопластика и риски."
  },
  "/filler": {
    "title": "Дермальные филлеры в Стамбуле",
    "eyebrow": "Эстетическая медицина",
    "lead": "Гиалуроновая кислота — это сахар, который уже есть в коже. Сшитая в гель и введённая под кожу, она восполняет утраченный объём и смягчает закрепившиеся складки. Это медицинская процедура с реальными рисками, а не косметическая услуга.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по дермальным филлерам в Platinya Clinic",
    "stats": [
      {
        "value": "30–60 мин",
        "label": "Приём"
      },
      {
        "value": "6–18 месяцев",
        "label": "Длительность"
      },
      {
        "value": "24–72 ч",
        "label": "Отёк и гематомы"
      }
    ],
    "candidate": {
      "heading": "Кому подходит, а кому нет",
      "intro": "Подходящему пациенту есть конкретная, описуемая задача — складка, западение, потерянный контур, — а не желание выглядеть как кто-то другой. Объём восполняют там, где он ушёл, а не добавляют везде, где можно.",
      "items": [
        "Потеря объёма в скулах, висках или средней зоне лица либо складки, сохраняющиеся в покое",
        "Линия челюсти или подбородок, утратившие чёткость, либо губы, истончившиеся с возрастом, а не изначально тонкие",
        "Хорошее общее здоровье, отсутствие активной инфекции или воспаления кожи в зоне вмешательства",
        "Реалистичные ожидания: филлеры восполняют объём, но не поднимают опустившееся лицо и не убирают дряблость кожи"
      ],
      "note": "Филлеры не вводят при беременности и кормлении, при активном акне, герпесе или инфекции, а также при известной аллергии на гиалуроновую кислоту или лидокаин. Антикоагулянты и некоторые добавки повышают риск гематом, и это оценивают заранее, а не игнорируют. Тем, кто просит постоянный филлер, отказывают и предлагают хирургическую консультацию."
    },
    "techniques": {
      "heading": "Препарат, слой и объём",
      "intro": "Результат гораздо больше зависит от того, куда введён препарат и сколько его использовано, чем от бренда на упаковке.",
      "items": [
        {
          "name": "Выбор геля",
          "text": "Филлеры на гиалуроновой кислоте различаются степенью сшивки и плотностью геля. Более мягкие — для губ и мелких морщин, более плотные — для глубоких слоёв над костью. В большинство входит лидокаин, что делает инъекцию комфортнее."
        },
        {
          "name": "Игла или канюля, и какой слой",
          "text": "Игла точна для губ и тонких складок; тупая канюля уменьшает гематомы и позволяет уложить препарат одним ходом. Глубокое введение над костью даёт опору, поверхностное — уточняет. Выбор слоя — клиническое решение, а не предпочтение."
        },
        {
          "name": "Умеренные дозы, поэтапно",
          "text": "Недовести и оценить результат через две-четыре недели безопаснее, чем корректировать за один сеанс. Переполненные ткани растягиваются, а растянутая кожа не сокращается обратно — так лица начинают выглядеть наполненными, а не отдохнувшими."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до контроля",
      "steps": [
        {
          "name": "Консультация",
          "text": "Лицо оценивают в покое и в движении, делают фотографии, изучают анамнез: беременность, аутоиммунные заболевания, герпес, прежние филлеры и места их введения. Ранее введённый постоянный филлер полностью меняет план."
        },
        {
          "name": "Планирование и согласие",
          "text": "Зоны, препарат, объём и стоимость согласуют письменно до вскрытия упаковки. Объясняют риски, включая сосудистую окклюзию, и сообщают, что гиалуронидаза — фермент, растворяющий препарат, — есть в клинике."
        },
        {
          "name": "Приём",
          "text": "Тридцать-шестьдесят минут вместе с аппликационной анестезией. Сами инъекции занимают десять-двадцать из этих минут. Губы и слёзная борозда наиболее чувствительны; большинство описывает ощущение давления, а не боли."
        },
        {
          "name": "Первые 72 часа",
          "text": "Отёк максимален через 24–48 часов, гематомы могут сходить неделю. Избегайте тепла, сауны, интенсивных нагрузок и алкоголя 24–48 часов, а лечения зубов — две недели, если обрабатывались губы или носогубная область. Сон с приподнятой головой помогает первую ночь."
        },
        {
          "name": "Контроль через две-четыре недели",
          "text": "Результат оценивают, когда отёк ушёл. Небольшая добавка иногда уместна; коррекцию не делают в первую неделю, когда всё выглядит больше, чем будет. Дальнейшее лечение планируют по тому, сколько препарат реально держится в ваших тканях."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Это медицинские инъекции в зону сосудистой сети. Серьёзные риски редки, но именно из-за них процедура должна проводиться в клинике, где есть врач и антидот.",
      "items": [
        "Гематомы, отёк и болезненность в течение нескольких дней — часто, и чаще при приёме антикоагулянтов",
        "Сосудистая окклюзия: препарат перекрывает артерию, вызывая боль, побледнение и, при отсутствии лечения, некроз кожи и рубцы; гиалуронидазу нужно ввести в течение часов",
        "Потеря зрения при эмболизации в сосуды сетчатки — очень редко, в значительной мере необратимо, и поэтому некоторые зоны обрабатывают только опытные специалисты",
        "Уплотнения, узелки или отсроченные воспалительные реакции через месяцы, иногда на фоне болезни или вакцинации",
        "Асимметрия, миграция препарата или переполненный вид, который нельзя полностью убрать за один сеанс"
      ],
      "note": "Гиалуроновую кислоту можно растворить гиалуронидазой — поэтому это единственный филлер, который стоит использовать на лице. Постоянные препараты и несертифицированные вещества удалить нельзя, и они — самая частая причина, по которой пациенту отказывают или направляют его к хирургу."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это больно?",
          "a": "Анестезирующий крем наносят на двадцать-тридцать минут, и в большинство препаратов входит лидокаин. Губы и зона под глазами наиболее чувствительны — это дискомфорт, а не боль, и он длится секунды на инъекцию."
        },
        {
          "q": "Это можно убрать?",
          "a": "Да, если это гиалуроновая кислота: гиалуронидаза растворяет её за день-два. Это не повод переливать, но именно поэтому препарат важнее цены."
        },
        {
          "q": "Будет ли это заметно?",
          "a": "Нет, если препарат введён в правильный слой и в умеренном объёме. Заметный результат обычно означает слишком много препарата, слишком поверхностно, в зоне, которой нужна была опора, а не объём."
        },
        {
          "q": "Как часто нужно повторять?",
          "a": "Каждые шесть-восемнадцать месяцев в зависимости от препарата, зоны и того, как быстро он у вас расщепляется. Губы и подвижные зоны обычно требуют добавления раньше, чем глубокая опора скул."
        }
      ]
    },
    "ctaBand": {
      "heading": "Спросите врача, что действительно нужно вашему лицу",
      "text": "Отправьте две фотографии — анфас и в полупрофиль, в покое — и врач их посмотрит. Вы получите честный ответ, подходящий ли филлер и что ещё может быть вариантом.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Филлеры — рецептурные медицинские изделия, и они уместны только после консультации с квалифицированным специалистом; показания различаются от пациента к пациенту.",
    "seoTitle": "Филлеры для лица в Стамбуле | Platinya",
    "seoDesc": "Дермальные филлеры в Стамбуле: приём 30–60 минут, результат на 6–18 месяцев, отёк 24–72 часа. Показания, препараты и риски."
  },
  "/face-botox": {
    "title": "Ботокс для лица в Стамбуле",
    "eyebrow": "Эстетическая медицина",
    "lead": "Ботулотоксин блокирует сигнал, который заставляет мышцу сокращаться. Введённый небольшими рассчитанными дозами в верхнюю зону лица, он смягчает морщины, прорезанные движением, — и эффект проходит, в этом и смысл.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по ботулотоксину в Platinya Clinic",
    "stats": [
      {
        "value": "15–30 мин",
        "label": "Приём"
      },
      {
        "value": "10–14 дней",
        "label": "Полный эффект"
      },
      {
        "value": "3–4 месяца",
        "label": "Длительность"
      }
    ],
    "candidate": {
      "heading": "Кому подходит, а кому нет",
      "intro": "Токсин работает с морщинами, созданными движением. Он ничего не делает с утраченным объёмом или опустившейся кожей — для них нужны филлер или операция, и предложение токсина в таких случаях приводит к разочарованию.",
      "items": [
        "Морщины между бровями, горизонтальные морщины лба и «гусиные лапки», видимые в движении",
        "Морщины, которые ещё динамические — появляются при нахмуривании или улыбке, — а не закреплены в покое",
        "Хорошее общее здоровье и отсутствие причин избегать рецептурного препарата",
        "Реалистичные ожидания: лицо выглядит менее напряжённым, а не моложе, и эффект временный"
      ],
      "note": "Ботулотоксин не вводят при беременности и кормлении, при нервно-мышечных заболеваниях — таких как миастения, синдром Ламберта — Итона или болезнь двигательного нейрона, — а также при известной аллергии на препарат или его альбуминовый носитель. Активная инфекция в месте инъекции и уже имеющееся опущение века — относительные причины подождать или выбрать другую тактику."
    },
    "techniques": {
      "heading": "Куда вводится и сколько",
      "intro": "Дозы измеряются в единицах, специфичных для каждого бренда, и не сопоставимы между ними. Важна схема инъекций, выбранная по тому, как реально двигаются ваши мышцы.",
      "items": [
        {
          "name": "Глабелла — морщины между бровями",
          "text": "Обычно первая обрабатываемая зона, как правило 20–30 единиц в пять точек. Здесь самый предсказуемый результат, но и здесь неверно введённая доза может вызвать опущение века."
        },
        {
          "name": "Лоб",
          "text": "Обычно 10–20 единиц, чтобы смягчить горизонтальные линии, не уплощая бровь целиком. Обработка только лба, без глабеллы, часто приподнимает внутренний край брови и выглядит странно — зоны планируют вместе."
        },
        {
          "name": "«Гусиные лапки»",
          "text": "Обычно 6–12 единиц на сторону, три точки вокруг наружного угла глаза. Зона поверхностная и близкая к краю орбиты, поэтому гематомы часты, а дозу держат низкой, чтобы избежать тяжёлого, закрытого взгляда."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до контроля",
      "steps": [
        {
          "name": "Консультация",
          "text": "Лицо наблюдают в покое и в движении — нахмуривание, поднимание бровей, прищур, — потому что дозу выбирают по мышце, а не по морщине. Изучают анамнез, препараты и прежнее лечение токсином, делают фотографии."
        },
        {
          "name": "Приём",
          "text": "Пятнадцать-тридцать минут. Анестезия не нужна; по желанию прикладывают лёд. Тонкая игла, несколько небольших инъекций по несколько секунд. Вы можете сразу вернуться к работе."
        },
        {
          "name": "Первые 24 часа",
          "text": "Не тереть и не массировать зону четыре часа, не лежать четыре часа, без спортзала, сауны и алкоголя 24 часа. Небольшая головная боль и мелкие гематомы обычны; макияж можно наносить в тот же день, если кожа не повреждена."
        },
        {
          "name": "С третьего по четырнадцатый день",
          "text": "Действие начинается примерно на второй-третий день, полный эффект достигается к 10–14 дням. Оценка раньше ведёт к ненужным добавкам — контроль назначают на 14-й день."
        },
        {
          "name": "Контроль, затем поддержка",
          "text": "Через две недели проверяют схему и при необходимости делают небольшую коррекцию. Эффект держится три-четыре месяца, иногда меньше у тех, кто быстро метаболизирует препарат. Лечение каждые три-четыре месяца удерживает результат без наращивания доз."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Это рецептурный препарат, и риски связаны с самим токсином, а не с иглой.",
      "items": [
        "Гематомы, отёк и умеренная головная боль на день-два, чаще вокруг глаз",
        "Опущение века или брови (птоз) примерно в 1–2% случаев обработки глабеллы — временное, проходит за две-четыре недели, иногда помогают капли",
        "Асимметрия или бровь, которая сидит выше с одной стороны, обычно корректируется на двухнедельном контроле",
        "Неестественное выражение — уплощённый лоб или «бровь Спока» — из-за дозы или схемы, не соответствующих мышцам",
        "Сухость глаза, отёчность века или затруднение поднять бровь, и редко — общая слабость или гриппоподобная реакция"
      ],
      "note": "Сообщите специалисту о каждом препарате и добавке, о прежних обработках токсином и о том, сколько они держались, а также о семейной истории нервно-мышечных заболеваний. Токсин не лечит дряблую кожу и утраченный объём и не заменяет хирургическую консультацию, когда лицу нужно именно это."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Лицо будет выглядеть застывшим?",
          "a": "При рассчитанной дозе нет. Цель — смягчить движение, а не остановить его. Застывший вид возникает, когда все зоны обрабатывают на полную дозу, и это обратимо — в этом преимущество перед операцией."
        },
        {
          "q": "Когда я увижу результат?",
          "a": "Движение начинает смягчаться примерно на второй-третий день, полный эффект есть к 10–14 дням. Всё, что выглядит неравномерно раньше, обычно ещё развивается."
        },
        {
          "q": "Что будет, если я прекращу?",
          "a": "Мышца возвращается к прежней активности за несколько месяцев, и морщины возвращаются туда, где были. Ухудшения по типу рикошета нет, хотя морщины, подавлявшиеся годами, поначалу могут казаться более закреплёнными."
        },
        {
          "q": "Можно ли сочетать с филлером?",
          "a": "Часто да — токсин для движения, филлер для объёма, — и их нередко делают в один визит. Порядок и сроки определяет специалист, поскольку и то и другое меняет оценку лица."
        }
      ]
    },
    "ctaBand": {
      "heading": "Спросите врача, токсин ли здесь правильный ответ",
      "text": "Отправьте две фотографии — с нахмуренными бровями и в покое — и врач их посмотрит. Вы получите честный ответ, мышечные ли это морщины и что ещё понадобилось бы, если нет.",
      "button": "Отправить фотографии"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Ботулотоксин — рецептурный препарат, его вводят только после консультации с квалифицированным специалистом; показания и доза различаются от пациента к пациенту.",
    "seoTitle": "Ботокс для лица в Стамбуле | Platinya",
    "seoDesc": "Ботокс для лица в Стамбуле: приём 15–30 минут, полный эффект через 10–14 дней, действие 3–4 месяца. Зоны, дозы и риски."
  },
  "/silicone": {
    "title": "Увеличение груди силиконовыми имплантами в Стамбуле",
    "eyebrow": "Контурирование тела",
    "lead": "Увеличение груди добавляет объём и улучшает симметрию с помощью импланта, установленного под тканью молочной железы или под мышцей. Оно меняет размер и форму, но не поднимает грудь, которая уже опустилась.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по увеличению груди в Platinya Clinic",
    "stats": [
      {
        "value": "1–2 ч",
        "label": "Длительность операции"
      },
      {
        "value": "1 ночь",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "4–6 недель",
        "label": "Без спорта"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Отправная точка — ваши ткани: их толщина, упругость и положение соска, а не желаемый размер чашки. Имплант подбирают под грудную клетку.",
      "items": [
        "Изначально небольшая грудь или размер, который никогда не соответствовал остальным пропорциям",
        "Заметная асимметрия между сторонами",
        "Объём, утраченный после кормления или снижения веса, при сохранившейся упругости кожи",
        "Опустевшая верхняя часть груди, где умеренный имплант возвращает контур"
      ],
      "note": "Если сосок находится ниже складки под грудью, речь о птозе, и один имплант это не исправит — он может сделать хуже. Нужна подтяжка, с имплантом или без. Маммографию или УЗИ назначают до операции с учётом возраста и семейного анамнеза, а любое образование обследуют в первую очередь."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Три решения принимают вместе: что вводится, куда и как устанавливается. Каждое меняет вид, восстановление и риск.",
      "items": [
        {
          "name": "Имплант: круглый или анатомический",
          "text": "Современные импланты заполнены связным силиконовым гелем, который держит форму. Круглые дают наполненность верхней части; анатомические (каплевидные) повторяют естественный наклон и обычно имеют текстурированную поверхность, чтобы не поворачиваться. Поверхность и форму выбирают вместе с хирургом, и у обоих вариантов есть компромиссы."
        },
        {
          "name": "Слой: под мышцей или двойной",
          "text": "Размещение под большой грудной мышцей скрывает край импланта и подходит при тонких тканях; при двойном слое нижнюю часть мышцы мобилизуют, чтобы имплант лежал естественно, а верхняя его прикрывала. Над мышцей восстанавливаются быстрее, но у худых пациентов имплант заметнее."
        },
        {
          "name": "Доступ",
          "text": "Под грудью в складке — самый частый и даёт наиболее прямой контроль. Вокруг ареолы скрывает рубец в зоне изменения пигмента, но немного повышает риск изменения чувствительности соска; через подмышку рубца на груди нет, но точность ниже."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Измерения грудной клетки, оценка качества кожи и положения соска, разговор о желаемом размере — с примеркой размеров, а не по фотографии. Маммография или УЗИ по показаниям, анализы крови и письменный план с указанием импланта."
        },
        {
          "name": "Подготовка",
          "text": "Курение прекращают за четыре недели, антикоагулянты и некоторые добавки — примерно за десять дней, есть и пить нельзя шесть-восемь часов. Компрессионный бюстгальтер покупают заранее и договариваются о помощи на первые три-четыре дня: поднимать тяжести и вести машину нельзя."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом, от одного до двух часов. Имплант устанавливают, положение проверяют при посаженном положении пациентки во время операции, разрез ушивают послойно. Большинство пациентов остаются на одну ночь, компрессионный бюстгальтер подбирают до выписки."
        },
        {
          "name": "Первые две недели",
          "text": "Стянутость и отёк сильнее в первые три-пять дней, грудь сидит высоко. Компрессионный бюстгальтер носят днём и ночью, дренажи редки, первый душ назначают в клинике. Спать на спине с приподнятым положением удобнее."
        },
        {
          "name": "С третьей по шестую неделю",
          "text": "Отёк спадает, импланты опускаются в своё положение за шесть-двенадцать недель. К офисной работе обычно можно вернуться через одну-две недели. Спортзал, бег, бассейн и тяжёлые нагрузки — через четыре-шесть недель; нагрузку на верхнюю часть тела вводят постепенно после этого."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Имплант — это изделие, у него есть срок службы и вероятность отказа. Вот риски, которые важны, включая редкие.",
      "items": [
        "Капсулярная контрактура — рубцовая ткань вокруг импланта стягивается, грудь становится плотной, круглой и иногда болезненной; это лечится, но может вернуться",
        "BIA-ALCL — редкая лимфома капсулы импланта, связанная главным образом с текстурированными имплантами и появляющаяся спустя годы как отёк или скопление жидкости; лечится удалением импланта и капсулы",
        "Разрыв или утечка, которые могут не давать симптомов и обнаруживаются на снимках, а также волнистость и видимые края через тонкую кожу",
        "Инфекция, которая может потребовать удаления импланта и его замены позже, и изменение чувствительности соска или груди — часто временное, иногда постоянное",
        "Кровотечение, гематома и, редко, тромбоз — их риск снижают ранней ходьбой и компрессией"
      ],
      "note": "Сообщите о любых перенесённых операциях на груди, семейной истории рака груди или яичников, аутоиммунных заболеваниях и курении. Импланты не мешают скринингу рака груди, но меняют технику маммографии — скажите о них, когда записываетесь на обследование."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько служат импланты?",
          "a": "Это не пожизненные изделия. Многие стоят десять-пятнадцать лет и дольше, но разрыв, контрактура или изменение формы могут приблизить замену. Фиксированного графика замены нет: имплант проверяют — осмотром и, при необходимости, УЗИ или МРТ — и меняют, если есть причина."
        },
        {
          "q": "Смогу ли я кормить грудью?",
          "a": "Большинство женщин может, особенно при разрезе в складке и двойном слое, которые в значительной мере сохраняют млечные протоки и иннервацию. У некоторых выработка меньше, а разрез вокруг ареолы повышает риск изменения чувствительности соска. Операцию стоит планировать с учётом будущей беременности."
        },
        {
          "q": "Вызывают ли импланты рак груди?",
          "a": "Не показано, что силиконовые импланты вызывают рак груди. BIA-ALCL — отдельная редкая лимфома рубцовой капсулы вокруг импланта, а не рак груди, и именно поэтому любой новый отёк, образование или боль вокруг импланта обследуют, а не наблюдают. Риск низкий, но он реальный, и о нём стоит знать."
        },
        {
          "q": "Может, мне нужна подтяжка?",
          "a": "Если сосок находится на уровне складки или ниже — да, либо подтяжка с меньшим имплантом. Имплант добавляет объём вперёд, а не вверх, и в опустившейся груди может дать более тяжёлую и низкую форму. Это оценивают стоя, и это самая частая причина, по которой план меняется на консультации."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Видов анфас и сбоку в облегающей одежде достаточно, чтобы обсудить, хватит ли одного импланта, какой объём примерно подходит вашей фигуре и что включает операция. Координатор ответит с планом и письменным расчётом.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Увеличение груди имплантами в Стамбуле | Platinya",
    "seoDesc": "Увеличение груди силиконовыми имплантами в Стамбуле: операция 1–2 часа, одна ночь в стационаре, без спорта 4–6 недель. Риски и уход."
  },
  "/butt-augmentation-surgery": {
    "title": "Увеличение ягодиц (BBL) в Стамбуле",
    "eyebrow": "Контурирование тела",
    "lead": "Увеличение ягодиц меняет форму и выступ ягодиц — либо переносом жира из других зон тела, либо установкой импланта. Это одна из самых требовательных операций в контурировании тела — и для хирурга, и для восстановления.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по увеличению ягодиц в Platinya Clinic",
    "stats": [
      {
        "value": "3–5 ч",
        "label": "Длительность операции"
      },
      {
        "value": "1–2 ночи",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "2–3 недели",
        "label": "Осторожное сидение"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Для переноса жира нужен жир, который можно перенести, и кожа, способная вместить новый объём. И то и другое оценивают стоя, и оба условия решают, возможна ли операция вообще.",
      "items": [
        "Достаточный объём жира на животе, боках, спине или бёдрах при стабильном весе",
        "Ягодицы плоские, квадратные или без выступа в профиль",
        "Асимметрия или потеря формы после снижения веса",
        "Хороший тонус кожи и отсутствие в анамнезе тромбозов или проблем после прежней липосакции"
      ],
      "note": "Это не операция для снижения веса и не замена тренировкам. При недостаточном весе забирать может быть нечего, и тогда единственный путь — имплант, с другим набором рисков. Курение, нарушения свёртываемости и неконтролируемый диабет — причины пересмотреть решение."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Под одним названием существуют две операции. Это не варианты одной: они различаются материалом, восстановлением и серьёзными рисками.",
      "items": [
        {
          "name": "Перенос жира (бразильская подтяжка ягодиц)",
          "text": "Жир забирают липосакцией с живота, боков или спины, отмывают и дают отстояться, затем вводят в ягодицы небольшими порциями. Это собственная ткань, поэтому ощущение естественное, а донорские зоны одновременно моделируются. Приживается не весь жир."
        },
        {
          "name": "Импланты ягодиц",
          "text": "Цельный силиконовый имплант устанавливают через разрез в складке между ягодицами, под фасцию или в мышцу. Он даёт предсказуемый объём, который не уменьшается, но это инородное тело с риском смещения, инфекции и образования капсулы, а рубец находится в чувствительной зоне."
        },
        {
          "name": "Сочетание и коррекция",
          "text": "Перенос жира можно сочетать с небольшим имплантом или повторить через шесть-двенадцать месяцев, чтобы добавить объём, когда первый перенос устоялся. Коррекция после прежнего BBL обычно сложнее первой операции, потому что рубцовая ткань меняет слои."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Фотографии стоя, оценка донорского жира и эластичности кожи, анамнез, включая тромбозы, кровотечения и перенесённые операции. Анализы крови и, при необходимости, заключение кардиолога или анестезиолога до согласования даты."
        },
        {
          "name": "Подготовка",
          "text": "Курение прекращают минимум за четыре недели: никотин влияет на приживаемость жира и заживление. Антикоагулянты, гормональные контрацептивы и некоторые добавки обсуждают и при необходимости отменяют. Купите свободную одежду и подушку для сидения после BBL и договоритесь о помощи дома: нормально лежать и сидеть неделями не получится."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом, от трёх до пяти часов. Жир забирают, обрабатывают и вводят небольшими порциями, стараясь держаться вдали от глубоких сосудов. Надевают компрессионное бельё, большинство пациентов остаются на одну-две ночи."
        },
        {
          "name": "Первые две недели",
          "text": "Спать нужно на животе или на боку, сидеть — только на специальной подушке и недолго. Донорские зоны в гематомах и болезненны, бельё носят постоянно. Ходить рекомендуется с первого дня; ягодицы отёчны, и форма ещё не окончательная."
        },
        {
          "name": "С третьей по двенадцатую неделю",
          "text": "Сидеть становится комфортно через две-три недели, вести машину — через две-три, тренироваться — через шесть-восемь. Отёк спадает за три месяца; прижившийся жир остаётся навсегда, но окончательную форму оценивают через три-шесть месяцев."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "У этой операции есть специфичный для неё серьёзный риск, и о нём стоит сказать прямо, а не вскользь.",
      "items": [
        "Жировая эмболия — жир попадает в кровоток и достигает лёгких; это может быть смертельно, и ни одна техника не устраняет риск полностью",
        "Жировой некроз, масляные кисты и уплотнения в зонах переноса, иногда требующие дренирования",
        "Инфекция, которая в глубоком слое ягодиц трудно поддаётся лечению и может потребовать удаления импланта, а также серома или замедленное заживление в донорских зонах",
        "Асимметрия, неровность контура или результат меньше запланированного, потому что часть жира не приживается",
        "Тромбоз или тромбоэмболия лёгочной артерии, риск которых снижают ранней ходьбой и компрессией, — и, при имплантах, смещение, капсулярная контрактура и плотные рубцы"
      ],
      "note": "Спросите любую клинику напрямую, как она избегает глубокого внутрисосудистого введения, кто проводит анестезию и что происходит при осложнении. Клиника, которая отвечает уклончиво о жировой эмболии, — не та клиника, куда стоит записываться."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько жира приживается?",
          "a": "Доля переменная: значительная часть часто рассасывается, и результат меньше непосредственного послеоперационного объёма. Поэтому операцию планируют консервативно и иногда через шесть-двенадцать месяцев нужен второй сеанс. Ни один хирург не может обещать процент."
        },
        {
          "q": "Когда можно нормально сидеть?",
          "a": "Две-три недели сидеть только на подушке и недолго, спать на животе или на боку. Считается, что длительное давление в первые недели снижает приживаемость жира. За руль — через две-три недели, длительные перелёты — через четыре-шесть."
        },
        {
          "q": "BBL опасен?",
          "a": "Он несёт реальный риск жировой эмболии, которая может быть смертельной, и этот риск выше, чем у большинства косметических операций. Его снижает аккуратная техника — небольшие канюли, обход глубокой мышцы и крупных сосудов, ограничение объёма, — но не устраняет. Решение о том, что риск не оправдан, вполне законно."
        },
        {
          "q": "Жир или имплант — что лучше?",
          "a": "Жир даёт естественное ощущение и моделирует донорские зоны, но объём частично теряется, а предел — сколько жира у вас есть. Имплант даёт предсказуемый объём без второй зоны операции, ценой инородного тела и более высокого риска инфекции и смещения. Обычно решает распределение собственных тканей."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Видов сбоку и сзади в облегающей одежде достаточно, чтобы хирург оценил выступ и донорский жир — и честно сказал, возможен ли перенос. Координатор ответит с планом и письменным расчётом.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Увеличение ягодиц (BBL) в Стамбуле | Platinya",
    "seoDesc": "Увеличение ягодиц в Стамбуле: операция 3–5 часов, 1–2 ночи в стационаре, осторожное сидение 2–3 недели. Перенос жира, импланты и риски."
  },
  "/liposuction": {
    "title": "Липосакция в Стамбуле (VASER и тумесцентная)",
    "eyebrow": "Контурирование тела",
    "lead": "Липосакция удаляет жир из определённых зон, чтобы изменить контуры тела. Это операция контурирования: цифра на весах почти не меняется, меняется то, где расположен жир.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по липосакции в Platinya Clinic",
    "stats": [
      {
        "value": "1–3 ч",
        "label": "Длительность операции"
      },
      {
        "value": "Один день",
        "label": "или одна ночь"
      },
      {
        "value": "4–6 недель",
        "label": "Компрессионное бельё"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Результат определяют две вещи: сколько жира можно удалить и насколько хорошо кожа сократится позже. Второе пациенты недооценивают чаще всего.",
      "items": [
        "Локальный жир на животе, боках, спине, бёдрах или руках, не меняющийся от тренировок",
        "Вес стабилен около полугода и близок к тому, который вы намерены сохранять",
        "Кожа сохранила эластичность — ей нужно сократиться на новом контуре",
        "Отсутствие нарушений свёртываемости, неконтролируемого диабета и болезней сердца"
      ],
      "note": "Липосакция не лечит ожирение и не заменяет снижение веса. Если предстоит потерять много килограммов, сначала стоит их потерять: результат будет лучше и безопаснее. Если кожа уже дряблая, удаление жира из-под неё сделает дряблость заметнее — тогда речь об иссечении кожи, а не о дополнительной липосакции."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Вся липосакция выполняется через небольшие разрезы канюлей. Различается то, как жир разрыхляют перед аспирацией и какую площадь обрабатывают за один сеанс.",
      "items": [
        {
          "name": "Тумесцентная липосакция",
          "text": "Сначала вводят большой объём разведённого местного анестетика с адреналином: зона немеет, сосуды сужаются, кровотечение уменьшается. Затем жир аспирируют канюлей. Стандартная техника, на которой построены остальные."
        },
        {
          "name": "VASER (ультразвуковая)",
          "text": "Ультразвуковую энергию используют, чтобы разрыхлить жир до удаления. Считается, что это мягче для окружающих тканей и помогает коже сократиться, особенно на спине и боках. Медленнее, дороже и несёт собственный риск ожогов под кожей."
        },
        {
          "name": "Контурирование 360°",
          "text": "Живот, бока и спину обрабатывают как единый блок, чтобы переход вокруг талии был плавным, а не в виде отдельных участков. Операция длиннее и объём удаляется больше, поэтому её планируют тщательнее и восстановление дольше."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и планирование",
          "text": "Зоны размечают стоя, оценивают эластичность кожи и честно обсуждают ожидаемый объём — включая то, что не изменится. Анализы крови и, при необходимости, заключение кардиолога до согласования даты."
        },
        {
          "name": "Подготовка",
          "text": "Курение прекращают за четыре недели, антикоагулянты и некоторые добавки — примерно за десять дней, есть и пить нельзя шесть-восемь часов. Компрессионное бельё измеряют и заказывают заранее. Договоритесь о помощи дома на первые два-три дня."
        },
        {
          "name": "Операция",
          "text": "Под седацией или общим наркозом, от одного до трёх часов в зависимости от числа зон. Вводят раствор, жир аспирируют через разрезы в несколько миллиметров, бельё надевают в операционной. Большинство пациентов уходят домой в тот же день; при больших объёмах остаются на ночь."
        },
        {
          "name": "Первые две недели",
          "text": "Из разрезов день-два подтекает жидкость, бельё носят днём и ночью. Гематомы обширные и максимальны в первую неделю. Ходить с первого дня; к офисной работе обычно можно вернуться через три-семь дней."
        },
        {
          "name": "С третьей по двенадцатую неделю",
          "text": "Отёк уменьшается за четыре-шесть недель, и бельё носят всё это время. Тренировки возобновляют через четыре-шесть недель. Контур уплотняется за три-шесть месяцев, окончательный результат оценивают через шесть-двенадцать."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Липосакция распространена, но это по-прежнему операция, и среди её рисков есть серьёзные, а не только косметические.",
      "items": [
        "Неровность контура, втяжения или асимметрия — самая частая жалоба и самое трудное для исправления",
        "Дряблость или провисание кожи после удаления жира, если эластичность изначально была низкой",
        "Ожоги или некроз кожи, особенно при ультразвуковых техниках",
        "Инфекция, серома, требующая повторного дренирования, и замедленное заживление в местах разрезов",
        "Тромбоз, тромбоэмболия лёгочной артерии и жировая эмболия — редко, риск снижают ранней ходьбой и компрессией; повреждение брюшной стенки или органов ещё реже и вероятнее при агрессивной глубокой аспирации"
      ],
      "note": "Сообщите об антикоагулянтах, проблемах со свёртываемостью, болезнях сердца или печени и о прежней липосакции той же зоны. Существует предел того, сколько можно безопасно удалить за один сеанс; хирург, который соглашается на любой запрошенный объём, не проявляет осторожности."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько веса я потеряю?",
          "a": "Очень немного, и это намеренно: жир легче, чем кажется, а безопасный объём за сеанс ограничен. Изменение — в форме и в том, как сидит одежда. Если цель — снижение веса, это неподходящая операция."
        },
        {
          "q": "Жир вернётся?",
          "a": "Удалённые жировые клетки не возвращаются, но оставшиеся могут увеличиться при наборе веса — и обычно увеличиваются равномерно, поэтому форма может измениться. Результат защищает стабильный вес."
        },
        {
          "q": "Это лечит целлюлит?",
          "a": "Надёжно — нет. Целлюлит — это строение кожи и соединительнотканных тяжей под ней, а не просто жир. Липосакция иногда делает втяжения заметнее, потому что удаляет жир, который их заполнял. Относитесь скептически к тем, кто продаёт её как средство от целлюлита."
        },
        {
          "q": "Когда я увижу результат?",
          "a": "Раннее изменение видно через две-три недели, но отёк дольше скрывает истинный контур. Большая часть результата есть к трём месяцам, окончательная форма — к шести-двенадцати, тогда же рассматривают коррекцию, если она нужна."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Видов анфас, сбоку и сзади достаточно, чтобы сказать, какие зоны можно обработать, какой объём реалистичен и сократится ли кожа. Координатор ответит с планом и письменным расчётом.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Липосакция в Стамбуле (VASER) | Platinya",
    "seoDesc": "Липосакция в Стамбуле: операция 1–3 часа, один день в клинике, компрессионное бельё 4–6 недель. Техники, показания и риски."
  },
  "/gynecomastia": {
    "title": "Гинекомастия: операция в Стамбуле",
    "eyebrow": "Контурирование тела",
    "lead": "Гинекомастия — увеличение грудной железы у мужчин. Операция удаляет железу за соском, жир вокруг неё или и то и другое, но только после поиска причины, потому что часть причин медицинские, а часть обратимы.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по гинекомастии в Platinya Clinic",
    "stats": [
      {
        "value": "1–2 ч",
        "label": "Длительность операции"
      },
      {
        "value": "Один день",
        "label": "или одна ночь"
      },
      {
        "value": "3–4 недели",
        "label": "Компрессионный жилет"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Истинная гинекомастия — это железистая ткань, плотный диск за соском, и она не уходит от тренировок. Только жир — это псевдогинекомастия, и лечат её иначе.",
      "items": [
        "Плотный, иногда болезненный диск ткани за одним или обоими сосками",
        "Увеличение, стабильное два года и более после полового созревания",
        "Псевдогинекомастия: жир без железы у человека со стабильным весом",
        "Дискомфорт, асимметрия или ограничение в одежде и поведении"
      ],
      "note": "До операции исключают причину. Лекарства и вещества — каннабис, анаболические стероиды, алкоголь, некоторые препараты от давления и для простаты — самая частая обратимая причина. Гормональные нарушения, болезни щитовидной железы, печени или почек и, редко, опухоль яичка проявляются так же. Сначала анализы крови и осмотр яичек; если что-то найдено, это лечат, а не оперируют вокруг."
    },
    "techniques": {
      "heading": "Что можно сделать и как это выбирается",
      "intro": "Операцию планируют по тому, что реально есть — железа, жир или кожа, — и эти три компонента у разных мужчин представлены в разных пропорциях.",
      "items": [
        {
          "name": "Иссечение железы",
          "text": "Железу удаляют через полукруглый разрез вокруг нижней половины ареолы. Это единственный способ убрать плотную железистую ткань, и разрез обычно заживает хорошо, потому что идёт по краю пигмента. Часто на день-два оставляют небольшой дренаж."
        },
        {
          "name": "Липосакция",
          "text": "Применяется для жирового компонента и для сглаживания краёв, чтобы грудь не выглядела оперированной. Сама по себе она не удаляет железу, поэтому одна липосакция часто оставляет плотный комок за соском — самая частая причина коррекции."
        },
        {
          "name": "В сочетании с иссечением кожи",
          "text": "При выраженном увеличении или после большой потери веса остаётся избыток кожи, который не сократится. Его удаляют, рубец располагают вокруг ареолы или горизонтально по груди. Операция больше, и рубец нужно принять."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до восстановления",
      "steps": [
        {
          "name": "Консультация и обследование",
          "text": "Грудь осматривают лёжа и стоя, отличают железу от жира, осматривают яички. Анализы на гормоны и функцию печени и, по показаниям, УЗИ груди или яичек — до назначения любых дат."
        },
        {
          "name": "Подготовка",
          "text": "Вызывающий препарат отменяют по согласованию с лечащим врачом — никогда самостоятельно, если он назначен. Курение прекращают за четыре недели, антикоагулянты — примерно за десять дней, есть и пить нельзя шесть-восемь часов. Компрессионный жилет заказывают заранее."
        },
        {
          "name": "Операция",
          "text": "Под общим наркозом, от одного до двух часов. Железу иссекают, жир удаляют липосакцией, контур проверяют при посаженном положении пациента. Жилет надевают в операционной. Большинство уходят домой в тот же день, некоторые остаются на ночь."
        },
        {
          "name": "Первые две недели",
          "text": "Жилет носят днём и ночью, дренаж — если он есть — снимают через день-два. Отёк и гематомы выражены, грудь ощущается стянутой. К офисной работе через три-семь дней; без подъёма тяжестей и упражнений на грудь."
        },
        {
          "name": "С третьей по двенадцатую неделю",
          "text": "Жилет носят в общей сложности три-четыре недели. Аэробные нагрузки — через три-четыре недели, силовые упражнения на грудь — через шесть. Отёк спадает за три месяца, окончательный контур, включая возможные мелкие неровности, оценивают через шесть."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Большинство рисков здесь касаются контура, и один — того, что причина осталась невылеченной.",
      "items": [
        "Деформация контура — блюдцевидное втяжение, остаточное уплотнение или асимметрия сторон, если удалено слишком много или слишком мало ткани",
        "Рецидив, если железистая ткань оставлена или вызывающий препарат продолжает приниматься",
        "Онемение или повышенная чувствительность соска, обычно улучшающиеся за месяцы",
        "Плохое или расширенное рубцевание и, редко, потеря сосково-ареолярного комплекса при нарушении его кровоснабжения",
        "Тромбоз, риск которого снижают ранней ходьбой, и инфекция — вероятнее у курящих; гематома или серома могут потребовать дренирования и влияют на окончательную форму"
      ],
      "note": "Скажите честно, что принимаете: стероиды, каннабис, добавки, назначенные препараты. Это не осуждение, а разница между операцией, которая работает, и той, после которой всё возвращается. Если найдена гормональная причина, её лечат отдельно."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Это рак?",
          "a": "Сама гинекомастия не является раком груди и у мужчин обычно доброкачественна. Но одностороннее, плотное, фиксированное образование или выделения — это не то же самое и требует обследования, поэтому осмотр и, при необходимости, УЗИ делают до операции, а не после."
        },
        {
          "q": "Это вернётся?",
          "a": "Если железа иссечена правильно, а причина устранена, рецидив редок. Чаще возвращается после одной липосакции, когда железу оставили ради сохранения соска или когда продолжаются стероиды либо каннабис. Небольшая остаточная полнота — не то же самое, что рецидив."
        },
        {
          "q": "Нужно ли прекращать каннабис или стероиды?",
          "a": "Да, и не только ради заживления. И то и другое может поддерживать увеличение, и продолжение после операции — самый надёжный способ всё отменить. С назначенными препаратами иначе: их меняют только вместе с врачом, который их назначил."
        },
        {
          "q": "Останется ли заметный рубец?",
          "a": "Разрез идёт по нижнему краю ареолы и обычно превращается в тонкую линию за шесть-двенадцать месяцев. Если приходится удалять кожу, рубец длиннее — вокруг ареолы или поперёк груди. Он остаётся навсегда, и это главный компромисс операции."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте фотографии, чтобы получить первое мнение",
      "text": "Вида анфас и сбоку достаточно, чтобы понять, это железа, жир или кожа, — и нужны ли сначала анализы крови. Координатор ответит с планом и письменным расчётом.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Эта страница — общая информация, а не медицинская рекомендация. Показания, техника и риски определяются на консультации с хирургом.",
    "seoTitle": "Гинекомастия: операция в Стамбуле | Platinya",
    "seoDesc": "Операция при гинекомастии в Стамбуле: 1–2 часа, один день в клинике, компрессионный жилет 3–4 недели. Сначала ищут причину."
  },
  "/gastric-sleeve-surgery": {
    "title": "Рукавная резекция желудка в Стамбуле",
    "eyebrow": "Бариатрическая хирургия",
    "lead": "Желудок преобразуют в узкую трубку — удаляют примерно 60–70% его объёма, — поэтому он вмещает гораздо меньше и опорожняется медленнее. Это инструмент, который облегчает контроль аппетита и порций; вес за вас он не снижает.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по рукавной резекции желудка в Platinya Clinic",
    "stats": [
      {
        "value": "1–2 ч",
        "label": "Длительность операции"
      },
      {
        "value": "2–3 ночи",
        "label": "Пребывание в стационаре"
      },
      {
        "value": "12–18 месяцев",
        "label": "До стабилизации веса"
      }
    ],
    "candidate": {
      "heading": "Кому подходит операция",
      "intro": "Решение принимают не только по весу. Оно опирается на индекс массы тела, на сопутствующие избыточному весу заболевания, на то, что уже было испробовано под наблюдением, — и на готовность наблюдаться годами, а не месяцами.",
      "items": [
        "ИМТ 40 и выше либо 35 и выше при связанном с весом состоянии — сахарном диабете 2 типа, повышенном давлении или апноэ сна",
        "ИМТ 30 и выше при плохо контролируемом диабете 2 типа — допускается частью международных рекомендаций, решается индивидуально",
        "Предшествующие структурированные попытки снизить вес — диета, активность, поведенческая поддержка, — не удержавшие результат в долгую",
        "Готовность к пожизненному наблюдению: анализы крови, добавки и визиты в клинику, включая годы, когда вес стабилен"
      ],
      "note": "Операцию не назначают до психологической оценки, заключения анестезиолога и консультации диетолога. Активное злоупотребление веществами или нелеченное психическое заболевание откладывают операцию до лечения — не из-за правила, а потому что иначе наблюдение не выдержит."
    },
    "techniques": {
      "heading": "Как выполняется операция",
      "intro": "Принцип во всех случаях одинаковый; меняются диаметр оставляемой трубки и то, ушивается ли грыжа одновременно.",
      "items": [
        {
          "name": "Лапароскопический рукав",
          "text": "Пять-шесть небольших разрезов, камера и сшивающие аппараты, которые разделяют желудок по большой кривизне. Отделённую часть извлекают через один из портов, поэтому остаётся трубка, а не мешок с обходным соустьем."
        },
        {
          "name": "Калибровка — насколько узкая трубка",
          "text": "Трубку формируют на зонде, проведённом через рот, обычно 36–40 Fr. Уже — больше ограничения, но и больше сужений и рефлюкса; шире — меньше. Это решение хирурга, а не выбор пациента."
        },
        {
          "name": "Пластика грыжи пищеводного отверстия и рефлюкс",
          "text": "Во время операции осматривают диафрагму и при обнаружении грыжи пищеводного отверстия ушивают её в том же сеансе. Уже существующий рефлюкс после рукава может усилиться, поэтому его оценивают заранее, и иногда это меняет выбор операции."
        }
      ]
    },
    "journey": {
      "heading": "От консультации до долгосрочного наблюдения",
      "steps": [
        {
          "name": "Обследование",
          "text": "Анализы крови, включая железо, B12, фолаты, витамин D и функцию щитовидной железы; гастроскопия по показаниям; консультация диетолога; психологическая оценка и заключение анестезиолога. Только после этого предлагают дату."
        },
        {
          "name": "Две недели до операции",
          "text": "Низкокалорийная диета, обычно жидкая или с очень низкой энергетической ценностью, уменьшает печень, чтобы к желудку был безопасный доступ. Курение прекращают минимум за четыре недели. Антикоагулянты отменяют по указанию врача."
        },
        {
          "name": "Операция и пребывание",
          "text": "Под общим наркозом, от одного до двух часов. Большинство пациентов остаются на две-три ночи. На первый-второй день при любых сомнениях по линии степлерного шва выполняют исследование с контрастом, жидкость начинают в тот же день."
        },
        {
          "name": "Первые шесть недель",
          "text": "Жидкости одну-две недели, протёртая пища две недели, мягкая две, затем обычные текстуры. Небольшие порции, медленно, сначала белок, и жидкости отдельно от приёмов пищи. К офисной работе обычно можно вернуться через две-три недели."
        },
        {
          "name": "Долгосрочно",
          "text": "Витамин B12, железо, фолаты, витамин D и кальций пожизненно, с анализами крови через три, шесть и двенадцать месяцев, затем ежегодно. Наблюдение продолжают и когда вес перестал меняться — именно тогда появляются дефициты и возврат веса."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Рукав — это необратимое изменение здорового органа. Вот осложнения, о которых действительно предупреждают пациентов, и причина, по которой операцию выполняют в стационаре с бариатрическим обеспечением.",
      "items": [
        "Несостоятельность линии шва примерно у 1–3% пациентов, обычно между третьим и десятым днём; требуется дренирование, иногда стент, изредка повторная операция",
        "Кровотечение из линии шва или из селезёнки, может потребоваться трансфузия и, редко, повторная операция",
        "Сужение или перекрут трубки с повторной рвотой и затруднением глотания; лечат эндоскопическим расширением",
        "Новый или усилившийся кислотный рефлюкс — одна из самых частых жалоб после рукава, и причина, по которой часть пациентов направляют на шунтирование",
        "Долгосрочный дефицит B12, железа, фолатов, витамина D и кальция при пропуске добавок и контроля"
      ],
      "note": "Возврат веса случается, чаще всего с третьего года, когда порции снова растут, а наблюдение прекращается. Операция — инструмент, а не излечение: она даёт окно, в котором можно перестроить пищевые привычки, и это окно закрывается, если внутри него ничего не перестроено."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько веса я потеряю?",
          "a": "Обычно около 25–30% от общей массы тела за первые один-два года, хотя разброс между пациентами широк и зависит от исходного веса, соблюдения рекомендаций и наблюдения. Никто не может обещать цифру до обследования."
        },
        {
          "q": "Нужны ли добавки пожизненно?",
          "a": "В большинстве случаев да — витамин B12, железо, фолаты, витамин D и кальций, с анализами для их корректировки. Удалённая часть желудка вырабатывает внутренний фактор и кислоту, поэтому всасывание меняется необратимо."
        },
        {
          "q": "Это можно обратить?",
          "a": "Желудок не восстанавливается до исходной формы. Если рукав не справляется — тяжёлый рефлюкс, слабое снижение веса, возврат веса, — обычный следующий шаг — конверсия в желудочное шунтирование, а это более крупная операция."
        },
        {
          "q": "А беременность после операции?",
          "a": "Беременность возможна, но большинство хирургов советует подождать 12–18 месяцев, чтобы вес и питательный статус стабилизировались. Добавки и контроль продолжают в течение беременности."
        }
      ]
    },
    "ctaBand": {
      "heading": "Отправьте свой рост, вес и историю болезней",
      "text": "Их посмотрит бариатрический хирург, и координатор вернётся с ответом, разумно ли обследование, какие исследования нужны сначала, и с письменным расчётом стоимости — без обязательств.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания можно оценить только после полного обследования бариатрическим хирургом, включая психологическую и нутрициологическую оценку; результаты и риски у разных пациентов различаются.",
    "seoTitle": "Рукавная резекция желудка в Стамбуле | Platinya",
    "seoDesc": "Рукавная резекция желудка в Стамбуле: операция 1–2 часа, 2–3 ночи в стационаре, стабилизация веса через 12–18 месяцев. Показания и риски."
  },
  "/stomach-balloon": {
    "title": "Внутрижелудочный баллон в Стамбуле",
    "eyebrow": "Бариатрическая хирургия",
    "lead": "Баллон помещают в желудок и наполняют, поэтому места для еды остаётся меньше и чувство насыщения приходит раньше. Он стоит от шести до двенадцати месяцев, затем его удаляют. Это временное пособие, а не операция и не излечение ожирения.",
    "cta": "Записаться на бесплатную консультацию",
    "heroAlt": "Консультация по внутрижелудочному баллону в Platinya Clinic",
    "stats": [
      {
        "value": "20–30 мин",
        "label": "Установка"
      },
      {
        "value": "6–12 месяцев",
        "label": "Срок ношения"
      },
      {
        "value": "3–7 дней",
        "label": "До адаптации"
      }
    ],
    "candidate": {
      "heading": "Кому подходит",
      "intro": "Баллон подходит тому, кому нужно снизить вес перед чем-то другим — операцией на суставе, лечением бесплодия, пластикой грыжи, — или кому нужен ограниченный стартовый период, чтобы изменить пищевые привычки под наблюдением. Он не подходит тому, кто ищет процедуру, которая сделает всю работу сама.",
      "items": [
        "ИМТ примерно 27–35 без состояния, делающего гастроскопию небезопасной",
        "Вес, не отвечающий на диету и активность под наблюдением, либо медицинская причина снизить вес быстро",
        "Отсутствие перенесённых операций на желудке или пищеводе, большой грыжи пищеводного отверстия и активной язвы",
        "Готовность следовать программе питания в течение месяцев ношения и после удаления"
      ],
      "note": "Баллон сам по себе не является лечением при ИМТ выше 40, и его не предлагают беременным, тем, кто планирует беременность в течение года, и при активном расстройстве пищевого поведения. Обследование включает анамнез, анализы крови и, в зависимости от устройства, гастроскопию."
    },
    "techniques": {
      "heading": "Два способа установки баллона",
      "intro": "Оба занимают место в желудке. Различается то, как они туда попадают, сколько могут оставаться и нужна ли седация.",
      "items": [
        {
          "name": "Эндоскопический баллон",
          "text": "Устанавливают через рот гастроскопом под седацией, затем наполняют физиологическим раствором с красителем, чтобы утечка была видна. Занимает около 20–30 минут. Удаляют тем же способом по окончании разрешённого срока, обычно через шесть или двенадцать месяцев."
        },
        {
          "name": "Баллон, который проглатывают",
          "text": "Капсулу проглатывают с водой, проверяют на рентгене, затем наполняют газом через тонкий катетер. Без седации и без гастроскопии. Он остаётся около четырёх месяцев и рассчитан на естественное выведение, хотя иногда требуется удаление эндоскопом."
        },
        {
          "name": "Программа вокруг него",
          "text": "Ни одно устройство не работает без сопутствующей диеты: план под руководством диетолога, нормы белка, поведенческое сопровождение и структурированный переход к обычному питанию за недели до удаления. Именно эта часть определяет результат."
        }
      ]
    },
    "journey": {
      "heading": "От обследования до жизни после удаления",
      "steps": [
        {
          "name": "Обследование",
          "text": "Анамнез, проверка препаратов, анализы крови и гастроскопия, если устройство этого требует. Любую язву, грыжу или рефлюкс лечат до установки, а не после."
        },
        {
          "name": "День установки",
          "text": "Обычно без госпитализации. Седация для эндоскопического варианта; для проглатываемого — только вода и капсула. Несколько часов наблюдения, противорвотные препараты, и в тот же день домой."
        },
        {
          "name": "Первая неделя",
          "text": "Тошнота, спазмы и рвота часты и ожидаемы — желудок протестует против того, что внутри. Противорвотные таблетки, небольшое количество жидкости и, при необходимости, внутривенные вливания. У большинства состояние стабилизируется за три-семь дней."
        },
        {
          "name": "Месяцы ношения",
          "text": "Жидкости, затем мягкая пища, затем обычные текстуры за две-три недели. Порции меньше, потому что желудок меньше. Контроль диетолога каждые четыре-шесть недель; анализы крови, если поступление пищи остаётся низким."
        },
        {
          "name": "Удаление и после",
          "text": "Удаление занимает 20–30 минут. Аппетит обычно возвращается за дни или недели, и без привычек, построенных за время программы, вес возвращается. План поддержки — наблюдение диетолога, активность, иногда препараты — согласуют до того, как баллон извлекут."
        }
      ]
    },
    "risks": {
      "heading": "Что может пойти не так",
      "intro": "Баллон менее инвазивен, чем операция, но не лишён рисков. Вот осложнения, которые обсуждают до установки.",
      "items": [
        "Тошнота, рвота и спазмы в животе в первую неделю, иногда настолько выраженные, что нужны внутривенные вливания",
        "Рефлюкс, изжога и раздражение пищевода или слизистой желудка, пока баллон стоит",
        "Сдувание или миграция баллона, что может вызвать кишечную непроходимость, — нечасто, и это неотложное состояние",
        "Изъязвление, эрозия или, очень редко, перфорация стенки желудка, требующая операции",
        "Возврат веса после удаления, что часто бывает, если программу питания не продолжают"
      ],
      "note": "Баллон даёт время и меньший желудок, и ничего больше. Он не меняет то, как организм обращается с пищей, не лечит причины, по которым есть было трудно, а потерянный вес обычно умеренный — как правило, от 5% до 15% массы тела за время ношения."
    },
    "faq": {
      "heading": "Что спрашивают пациенты",
      "items": [
        {
          "q": "Сколько веса я потеряю?",
          "a": "Обычно порядка 5–15% массы тела за время ношения, с широким разбросом. Это меньше, чем при рукаве или шунтировании, и часть веса часто возвращается после удаления."
        },
        {
          "q": "Это больно?",
          "a": "Установка неболезненна: горло онемевают и применяют седацию. Первые три-семь дней обычно дискомфортны: тошнота, спазмы, рвота. Противорвотные препараты назначают до выписки."
        },
        {
          "q": "Можно ли есть нормально?",
          "a": "Обычные текстуры — да; обычные порции — нет. Слишком быстрая еда или слишком большой объём вызывают боль и рвоту, а газированные напитки и очень волокнистая пища переносятся некоторыми пациентами плохо."
        },
        {
          "q": "Что происходит после удаления?",
          "a": "Желудок возвращается к прежнему размеру за несколько дней. Аппетит часто возвращается быстро. Удержится ли вес, зависит от того, что было построено за эти месяцы, поэтому программа питания важнее устройства."
        }
      ]
    },
    "ctaBand": {
      "heading": "Узнайте, подходит ли баллон как отправная точка",
      "text": "Отправьте свой рост, вес и историю болезней. Их посмотрит бариатрический врач, и координатор ответит, что подходит вашему случаю — баллон или хирургическое обследование — и что это включает.",
      "button": "Связаться с координатором"
    },
    "disclaimer": "Общая информация, а не медицинская рекомендация. Показания зависят от обследования бариатрическим врачом, включая анамнез и, по показаниям, гастроскопию; результаты у разных пациентов различаются.",
    "seoTitle": "Внутрижелудочный баллон в Стамбуле | Platinya",
    "seoDesc": "Внутрижелудочный баллон в Стамбуле: установка 20–30 минут, ношение 6–12 месяцев, адаптация 3–7 дней. Показания, программа и риски."
  },
};
